export default {
  date: {
    formats: {
      default: '%d-%m-%Y',
      short: '%-d %B',
      long: '%-d %B %Y',
      with_day: '%A, %-d %B',
      without_day: '%-d %B, %Y',
    },
    day_names: [
      'Domenica',
      'Lunedì',
      'Martedì',
      'Mercoledì',
      'Giovedì',
      'Venerdì',
      'Sabato',
    ],
    abbr_day_names: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    month_names: [
      null,
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre',
    ],
    abbr_month_names: [
      null,
      'genn.',
      'febbr.',
      'mar.',
      'apr.',
      'magg.',
      'giugno',
      'luglio',
      'ag.',
      'sett.',
      'ott.',
      'nov.',
      'dic.',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 2,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%n %u',
        unit: '€',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'CAD',
      AUD: 'AUD',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 1,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Byte',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'Mila',
          million: 'Milioni',
          billion: 'Miliardi',
          trillion: 'Bilioni',
          quadrillion: 'Biliardi',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'mezzo minuto',
      less_than_x_seconds: {
        one: 'meno di un secondo',
        other: 'meno di %{count} secondi',
        few: 'meno di %{count} secondi',
        many: 'meno di %{count} secondi',
      },
      x_seconds: {
        one: '1 secondo',
        other: '%{count} secondi',
        few: '%{count} secondi',
        many: '%{count} secondi',
      },
      less_than_x_minutes: {
        one: 'meno di un minuto',
        other: 'meno di %{count} minuti',
        few: 'meno di %{count} minuti',
        many: 'meno di %{count} minuti',
      },
      x_minutes: {
        one: '1 minuto',
        other: '%{count} minuti',
        few: '%{count} minuti',
        many: '%{count} minuti',
      },
      about_x_hours: {
        one: "circa un'ora",
        other: 'circa %{count} ore',
        few: 'circa %{count} ore',
        many: 'circa %{count} ore',
      },
      x_days: {
        one: '1 giorno',
        other: '%{count} giorni',
        few: '%{count} giorni',
        many: '%{count} giorni',
      },
      about_x_months: {
        one: 'circa un mese',
        other: 'circa %{count} mesi',
        few: 'circa %{count} mesi',
        many: 'circa %{count} mesi',
      },
      x_months: {
        one: '1 mese',
        other: '%{count} mesi',
        few: '%{count} mesi',
        many: '%{count} mesi',
      },
      about_x_years: {
        one: 'circa un anno',
        other: 'circa %{count} anni',
        few: 'circa %{count} anni',
        many: 'circa %{count} anni',
      },
      over_x_years: {
        one: 'oltre un anno',
        other: 'oltre %{count} anni',
        few: 'oltre %{count} anni',
        many: 'oltre %{count} anni',
      },
      almost_x_years: {
        one: 'circa 1 anno',
        other: 'circa %{count} anni',
        few: 'quasi %{count} anni',
        many: 'quasi %{count} anni',
      },
      x_years: {
        one: '1 anno',
        other: '%{count} anni',
      },
      x_weeks: {
        one: '1 settimana',
        other: '%{count} settimane',
        few: '%{count} settimane',
        many: '%{count} settimane',
      },
      x_hours: {
        one: '1 ora',
        other: '%{count} ore',
      },
    },
    prompts: {
      year: 'Anno',
      month: 'Mese',
      day: 'Giorno',
      hour: 'Ora',
      minute: 'Minuto',
      second: 'Secondi',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: "Effettua l'upgrade a Pro",
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Fino a cinque immagini diverse',
        best_2: 'JPEG o PNG',
        best_3: 'Fino a %{size}',
        best_4: '%{resolution} pixel o più',
        best_5: 'Niente GIF o video (è così, ci spiace)',
        best_title: 'Quello che conta:',
        text: 'Metti te stesso o il tuo brand al centro di tutto con fino a cinque video o immagini in rotazione.',
        best_five: '%{videoResolution} pixel per i video',
        best_four: '%{resolution} pixel per le immagini',
        best_one: 'Fino a cinque video o immagini',
        best_six:
          'I wallpaper si alternano ogni %{rotationInterval} secondi, i video più lunghi di %{rotationInterval} secondi saranno tagliati',
        best_three: '%{size} per video/immagine',
        best_two: 'JPEG, PNG o MP4',
        notice:
          "Rullo di tamburi: sono arrivati i video di sfondo! <a href='/profile'>Metti subito un video come sfondo</a>.",
      },
      upsell: {
        benefit_one_alt: 'Ottieni una pagina WeTransfer tutta tua',
        heading_alt: 'Consegna il tuo lavoro con stile',
        benefit_one: 'Ottieni un dominio WeTransfer tutto tuo',
        benefit_three: 'Progetta le tue e-mail di trasferimento',
        benefit_two:
          'Mostra sfondi personalizzati quando qualcuno scarica i tuoi file',
        button: {
          action: 'Voglio saperne di più',
        },
        heading: 'Metti in risalto il tuo brand con WeTransfer Pro',
      },
      branding: {
        headline:
          "<strong>Invia il meglio.</strong> Fai un'ottima impressione ogni volta che qualcuno scarica i tuoi file.<br /> <strong>Ricevi con facilità.</strong> Chiunque può inviarti trasferimenti, come previsto dal tuo piano.",
        protip: {
          text: '<strong>Suggerimento:</strong> devi chiedere a qualcuno di inviarti un trasferimento? Inviagli un link speciale con la descrizione già compilata.',
          link: 'Scopri di più',
        },
      },
      pagename: 'Impostazioni del profilo',
      'onboarding-step-two':
        "Presenta i tuoi file con stile, personalizza il tuo profilo su WeTransfer e ammira il tuo nuovo look accedendo a <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Sfondi e-mail',
      sent_you_files: 'ti ha inviato dei file',
      email_background_instruction_with_spec:
        "Presenta le tue e-mail per i trasferimenti con stile scegliendo l'immagine da inserire sullo sfondo.   \nPer risultati ottimali, utilizza un'immagine con risoluzione %{resolution} pixel (tieni presente che dovremo tagliare immagini più grandi). La dimensione massima del file è %{size}.",
      receiving: 'E-mail del profilo',
      choose_wallpapers: 'Sfondi',
      'step-one-banner':
        'Per iniziare, scegli un URL per la tua pagina di WeTransfer. Puoi sempre modificarlo in un secondo momento.',
      description: {
        pro: "Con la tua pagina di WeTransfer puoi fare un'ottima impressione ogni volta che qualcuno scarica i tuoi file. E, sempre qui, chiunque può inviarti trasferimenti fino a 200 GB, come previsto dal tuo piano WeTransfer Pro.",
        premium:
          "Con la tua pagina di WeTransfer puoi fare un'ottima impressione ogni volta che qualcuno scarica i tuoi file. E, sempre qui, chiunque può inviarti trasferimenti di qualsiasi dimensione, come previsto dal tuo piano WeTransfer Premium.",
      },
      'instructions-1': 'Modifica nome e URL tutte le volte che vuoi.',
      'instructions-2':
        'Dopo aver scelto il nuovo URL, la tua pagina sarà aggiornata immediatamente.',
      title: 'Modifica la pagina',
      profile_url: 'URL del profilo',
    },
    payment: {
      never_actived_retry:
        'Il tuo account non è ancora attivo. Completa la registrazione per iniziare a usare <a href="/payment/retry">%{planName}</a>',
      pagename: 'Piano e pagamento',
      autorenew_heading: 'Dettagli del pagamento',
      autorenew_notice:
        'La tua iscrizione a %{planName} da %{deal} sarà rinnovata automaticamente il %{autorenewal_attempt}.',
      will_expire_notice:
        "La tua iscrizione a Pro <span class='payment__notice'>scadrà tra %{daysBetween} giorni</span>. Rinnova subito il tuo account o imposta il rinnovo automatico.",
      never_actived_notice:
        'Il tuo account non è ancora attivo. <a href="/payment/retry">Completa la tua registrazione per iniziare a usare Pro.</a>',
      manual_renewal_expiry_notice:
        'Il tuo account Pro scadrà in data %{expiry}.',
      to_checkout: 'Vai al checkout',
      updating: 'Caricamento in corso...',
      yes_disable: 'Sì, vai avanti',
      review_billing_link: 'Vuoi aggiornare il tuo metodo di pagamento?',
      autorenew_failed:
        "La tua iscrizione a Pro di %{deal}/%{period} <span class='payment__notice'><strong>scadrà tra %{daysBetween} giorni</strong>. Non ci è stato possibile rinnovare il tuo account, ti invitiamo a rinnovarlo manualmente prima del giorno <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Sei sicuro di voler interrompere il rinnovo automatico?',
      disable_autorenewal: 'Interrompi il rinnovo automatico',
      enable_autorenewal: 'Abilita il rinnovo automatico',
      renew_now: 'Rinnova adesso',
      subscription_expired: 'La tua iscrizione a Pro è terminata.',
      cancel_heading: 'È tempo di voltare pagina?',
      cancel_info:
        'Lo sappiamo, sono cose che capitano. Una volta annullata la tua iscrizione, conserveremo i tuoi file per altri 30 giorni (no, non sotto il cuscino, non pensare a cose strane), in caso ti sia dimenticato qualcosa. Potrai riattivare la tua iscrizione in qualsiasi momento.',
      cancel_info_subscription:
        'Lo sappiamo, sono cose che capitano. Una volta annullata la tua iscrizione, potrai continuare a usare il tuo account Pro fino al %{subscriptionExpiryDate}. Dopo questa data, conserveremo i tuoi file per altri 30 giorni (no, non sotto il cuscino, non pensare a cose strane), nel caso in cui ti sia dimenticato qualcosa. Potrai riattivare la tua iscrizione in qualsiasi momento.',
      cancel_now: "Annulla l'iscrizione",
      cancelling: 'Annullamento in corso...',
      confirm_cancel_subscription:
        'Sei sicuro di voler cancellare la tua sottoscrizione?',
      confirm_reactivate_subscription:
        'Ottima scelta! Ancora un ultimo clic per riattivare il tuo metodo di pagamento',
      manual_renewal_in_future_notice:
        'Il tuo abbonamento a Pro di %{deal}/%{period} scadrà tra %{daysBetween} giorni. Puoi rinnovare il tuo conto manualmente dopo il %{manual_renewal_available_at} oppure puoi attivare il rinnovo automatico subito.',
      reactivate_heading: 'Ricomincia da capo.',
      reactivate_content_top_pro:
        "Puoi riattivare la tua iscrizione a %{planName} e sarà come se non l'avessi mai annullata. In alternativa, puoi effettuare l'upgrade a WeTransfer Premium:",
      reactivate_content_top_premium:
        "Puoi riattivare la tua iscrizione a %{planName} e sarà come se non l'avessi mai annullata.",
      reactivate_content_bottom_pro:
        "Se effettui l'upgrade a Premium, ti verranno addebitati %{upfront_payment} e potrai iniziare immediatamente a usufruire di WeTransfer Premium. La tua nuova iscrizione di %{recurring_payment}/%{interval} si rinnoverà il %{recurring_date}.",
      reactivate_pro: 'Riattiva Pro',
      reactivate_premium: 'Riattiva Premium',
      reactivate_upgrade_to_premium: "Effettua l'upgrade a Premium",
      reactivating: "Stiamo riattivando l'account...",
      subscription_cancelled:
        'La tua sottoscrizione è stata cancellata e scadrà tra %{daysBetween} giorni.',
      subscription_reactivate_expired_notice:
        'Il tuo account Pro è stato cancellato.',
      subscription_reactivate_notice_pro:
        'La tua iscrizione a %{planName} è stata annullata e scadrà tra %{daysBetween} giorni.',
      subscription_reactivate_notice_premium:
        'La tua iscrizione a %{planName} è stata annullata e scadrà tra %{daysBetween} giorni.\nHai cambiato idea? Niente panico: tornare operativi è un gioco da ragazzi.',
      subscription_reactivate_notice_trial_before:
        'La tua iscrizione a %{planName} è stata annullata e scadrà tra %{daysBetween} giorni.\nPuoi continuare a usufruire della prova gratuita di WeTransfer Premium fino alla scadenza della tua iscrizione.',
      subscription_reactivate_notice_trial_after:
        'La tua iscrizione a %{planName} è stata annullata e scadrà tra %{daysBetween} giorni.\nPuoi continuare a usufruire della prova gratuita di WeTransfer Premium fino al %{trialExpiryDate}.',
      update_method_link: 'Aggiornamento dati di pagamento',
      autorenew_notice_teams:
        'La tua iscrizione a %{planName} da %{deal} sarà rinnovata automaticamente il %{autorenewal_attempt} per il tuo team composto da %{number_of_members} membri.',
      cancellation_cta: "Cancella l'iscrizione",
      cancellation_heading:
        'Pensi di non avere più bisogno dei vantaggi di %{planName}?',
      cancellation_heading_trial: "Annulla l'iscrizione",
      cancellation_text:
        'Se annulli la tua iscrizione, potrai approfittare delle funzionalità di Pro ancora fino al %{subscriptionExpiryDate}. Dopo questa data, il tuo account WeTransfer Pro sarà convertito in un account gratuito e i tuoi trasferimenti esistenti scadranno dopo 28 giorni.',
      cancellation_text_item_1: 'Inviare fino a %{transfer_limit}',
      cancellation_text_item_2:
        'Proteggere i tuoi trasferimenti con una password',
      cancellation_text_item_3:
        'Gestire e salvare %{storage_limit} di trasferimenti',
      cancellation_text_item_4:
        'Ottenere un tuo URL e una pagina Pro personalizzati',
      cancellation_text_item_heading:
        "L'account gratuito ti permette di inviare solo %{free_size_limit} per ciascun trasferimento. Non sarai più in grado di:",
      cancellation_text_new:
        'Se annulli la tua iscrizione ora, potrai utilizzare %{planName} fino al %{subscriptionExpiryDate}. Successivamente, verrà effettuato il downgrade al piano gratuito.<br /><br />Attenzione: i tuoi trasferimenti esistenti scadranno, al più tardi, entro 28 giorni dal termine della tua iscrizione.',
      cancellation_text_teams:
        'Se annulli la tua iscrizione ora, tu e il tuo team potrete utilizzare %{planName} fino al %{subscriptionExpiryDate}.<br /><br />Successivamente, tu e i membri del tuo team non avrete più la possibilità di inviare trasferimenti di file, creare presentazioni e gestire board condivise. Verrà effettuato il downgrade al piano gratuito e potrete solo accedere al vostro account WeTransfer personale.<br /><br />Attenzione: i tuoi trasferimenti esistenti scadranno, al più tardi, entro 28 giorni dal termine della tua iscrizione.',
      premium_trial: {
        feature_list_item_1: 'Nessun limite nelle dimensioni dei trasferimenti',
      },
      premium_upgrade: {
        cta: 'Passa a Premium',
        description:
          'Ti addebiteremo %{upfront_payment} e potrai iniziare subito con WeTransfer Premium. La tua nuova iscrizione da %{recurring_payment}/%{interval} sarà rinnovata il %{recurring_date}.',
        feature_list_item_1:
          'Invia trasferimenti senza limiti nella dimensione dei file',
        feature_list_item_2: 'Storage illimitato',
        feature_list_item_3: 'Portali e revisioni illimitati',
        feature_list_item_4: '%{storageLimit} di storage',
        heading: "Vuoi fare l'upgrade del tuo piano?",
      },
      unpaid_invoices: {
        heading: 'Hai delle fatture non pagate',
        item: {
          issued_on: 'Emessa il',
          pay_invoice: 'Paga fattura',
          pending_invoice: 'In attesa…',
        },
        subheading:
          "Sembra che si sia verificato un problema con i tuoi pagamenti precedenti. Salda tutte le fatture in sospeso per evitare l'annullamento dell'iscrizione a Pro.",
        subheading_2:
          'Se hai delle fatture in sospeso, abbi pazienza: riproveremo tra un paio di giorni e, non appena il pagamento sarà andato a buon fine, potrai cominciare a usufruire del tuo abbonamento.',
      },
      upgrade_cta: "Effettua l'upgrade",
      app_subscription_banner: {
        title: "Hai effettuato l'iscrizione da %{app_name}",
        content:
          'Per visualizzare o gestire la tua iscrizione, accedi al tuo account %{app_name} dal tuo telefono o computer.',
        go_to: 'Vai a',
        learn_more: 'Scopri di più',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: "Annulla l'iscrizione",
      cancellation_disclaimer:
        "*Attenzione: i tuoi trasferimenti esistenti scadranno, al più tardi, entro 28 giorni dal passaggio all'account gratuito.",
      'current-plan': 'Piano attuale',
      'free-forever': 'Gratis per sempre',
      'free-usp-1': 'Invia fino a 2 GB',
      'free-usp-2': 'Niente spazio di archiviazione',
      'free-usp-3': 'I trasferimenti scadono dopo 7 giorni*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Se annulli la tua iscrizione ora, potrai continuare a usare WeTransfer Pro fino al <b>%{expiration_date}</b>. Dopo questa data, passerai a un account WeTransfer gratuito, che comunque non è niente male.',
      pagename: 'Pensi di non avere più bisogno dei vantaggi di Pro?',
      'pro-usp-1': 'Invia e ricevi fino a %{transfer_limit}',
      'pro-usp-2': '1 TB di spazio di archiviazione',
      'pro-usp-3': 'Decidi tu quando far scadere i trasferimenti',
      'pro-usp-4':
        '<p>Una pagina Pro <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">tutta per te</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Sblocca Paste® Pro e Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Abbiamo cancellato la tua iscrizione e passerai a un account WeTransfer gratuito dopo il <b>%{ends_at}.</b></p> \n<p>Facci sapere perché ci stai lasciando e continueremo a migliorare WeTransfer anche pensando a te..</p>',
      reason_header: 'Che triste che vai via',
      cancel: 'Torna indietro',
      info: 'Dicci perché ci stai lasciando e continueremo a migliorare WeTransfer Pro anche pensando a te.',
      pagename: 'Prima di salutarci',
      yes_disable: 'Sì, procediamo',
    },
    payment_failed: {
      selected_product: 'Un %{duration} di %{planTier}',
      change: 'Aggiorna',
      complete_order: 'Completa il tuo ordine',
      description: 'Controlla i tuoi dati e completa il tuo ordine',
      description_error:
        'Qualcosa non ha funzionato — controlla i tuoi dati e procedi al pagamento',
      description_refused:
        'Non è stato possibile elaborare il pagamento — verifica i tuoi dati del pagamento e riprova',
      discount: 'Sconto',
      product_description: 'Un %{duration} di WeTransfer Pro',
      title: 'Hai quasi finito!',
      total: 'Totale',
      vat: 'IVA',
      your_details: 'I tuoi dati',
      your_order: 'Il tuo ordine',
      title_error: 'Uhmmm, sembra ci sia un problema',
      title_refused: 'Uhmmm, sembra ci sia un problema',
      payment_status_message:
        'Il tuo pagamento è andato a buon fine ma si è verificato un errore che ha impedito di aggiornare automaticamente il piano. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Contatta l\'assistenza</a>',
    },
    payment_methods: {
      billed_now: 'Totale fatturato adesso',
      info_content: {
        cancel_bullet:
          "Non ti preoccupare, l'opzione per cancellare la tua iscrizione si trova in Impostazioni account > Pagamento.",
        initial_payment_bullet:
          'Dopo il pagamento iniziale ti verranno addebitati %{price} %{interval} (a meno che tu non decida di cancellare la tua iscrizione, ma non lo faresti mai, vero? Vero?!)',
        update_payment_bullet:
          'Puoi sempre aggiornare i tuoi dati di pagamento e/o di fatturazione prima del tuo prossimo pagamento.',
        month:
          "- Dopo il pagamento iniziale, ti verranno addebitati %{price} al mese (a meno che tu decida di annullare la tua iscrizione a Pro… ma non lo faresti mai, vero? Vero?!)\n- Non preoccuparti, potrai trovare l'opzione di annullamento su Impostazioni account > Pagamento.\n- Puoi aggiornare il tuo metodo di pagamento e/o i dati aziendali in qualsiasi momento prima della scadenza del pagamento successivo.",
        year: "- Dopo aver effettuato il pagamento iniziale, ti verranno addebitati %{price} all'anno (a meno che tu non decida di cancellare la tua iscrizione a WeTransfer Pro, ma non lo faresti mai, vero?!).\n- Non ti preoccupare, è possibile procedere alla cancellazione in ogni momento andando su Account > Pagamento.\n- Puoi sempre aggiornare il tuo metodo di pagamento e/o i tuoi dati aziendali prima della scadenza del prossimo pagamento.",
      },
      payment_cta: 'Completa il pagamento',
      payment_term: {
        monthly: 'una volta al mese',
        yearly: "una volta all'anno",
      },
      payment_title: 'Pagamento',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Mensile',
        year: 'Annuale',
      },
      subtotal: 'Subtotale',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Il tuo metodo di pagamento',
      bancontact: 'Bancontact',
      card: 'Carta di credito',
      card_cvc: 'CVC',
      card_expiration: 'MM / AA',
      card_name: 'Nome sulla carta',
      card_number: 'Numero carta',
      complete_payment: 'Completa il tuo pagamento',
      creditcard: 'Carta di credito',
      discount: 'Sconto',
      do_not_refresh: 'Non aggiornare o chiudere questa pagina',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL è un metodo di pagamento olandese che consente di utilizzare il proprio conto corrente per effettuare il pagamento.',
      info: 'Aggiorna i metodi di pagamento',
      payment_in_progress: 'Il tuo pagamento è in fase di elaborazione...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/mese',
        year: '/anno',
      },
      select_bank: 'Seleziona la tua banca',
      select_country: 'Seleziona il paese',
      sofort: 'SOFORT',
      tax: 'IVA',
      title: 'Seleziona il tuo metodo di pagamento',
      total: 'Totale',
    },
    projects: {
      actions: {
        go_back: 'Tutti i progetti',
        discard: 'Elimina modifiche',
        edit: 'Modifica',
        remove_transfer:
          'Vuoi eliminare questo trasferimento? I file verranno rimossi da questo progetto e dai trasferimenti inviati.',
        save: 'Salva',
        share: 'Condividi',
      },
      transfer_actions: {
        download: 'Scarica',
      },
      added_at: 'alle %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copia link',
        link_copied: 'Link copiato negli appunti',
        content_label: 'Copia link in questo progetto',
        list_item_1: 'Accesso solo per download e visualizzazione',
        list_item_2: 'Il link non cambierà mai',
        title: 'Condividi progetto',
      },
      content: {
        empty_state:
          'Il progetto è attualmente vuoto. Inizia ad aggiungere alcuni file per avviare la sequenza temporale del progetto.',
      },
      logo_title: 'Torna su wetransfer.com',
      logo_tooltip_caption: 'Torna su WeTransfer',
      timestamp: '%{timeAgo} fa',
      chat: {
        owner_button_label: 'Psst… parla con noi',
        owner_offline_greeting:
          'Al momento siamo offline, ma comunicaci il tipo di problema che hai riscontrato e ti risponderemo entro un giorno lavorativo.',
        owner_online_greeting:
          'Comunicaci il tipo di problema che hai riscontrato e ti risponderemo il prima possibile',
        receiver_button_label: 'Hai qualche domanda? Siamo qui per aiutarti',
        receiver_offline_greeting:
          'Comunicaci il tipo di problema che hai riscontrato e ti risponderemo il prima possibile',
        receiver_online_greeting:
          'Comunicaci il tipo di problema che hai riscontrato e ti risponderemo il prima possibile',
      },
      created_by: 'Creato da %{user}',
      created_by_fallback: 'Creato',
      deliverable_clipboard_modal: {
        content_label: 'Copia link in questo prodotto finale',
        info: 'Chiunque potrà visualizzare il tuo progetto',
        title: 'Condividi prodotto finale',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Questo non è il progetto che stai cercando…',
        limit:
          'Il tuo potenziale è infinito, ma hai raggiunto il limite di caratteri',
        required: 'Sai cosa devi fare La compilazione è obbligatoria',
      },
      event: {
        project_created_byline:
          'Aggiungi dei file per mostrare su cosa stai lavorando.',
        project_created_title: 'Inizio del progetto',
      },
      file_count: {
        one: '%{count} file',
        other: '%{count} file',
      },
      just_now: 'proprio ora',
      labels: {
        description: 'Descrizione',
        name: 'Nome',
        new_name: 'Nomina il progetto',
      },
      logo: {
        cta: 'Aggiungi un logo',
        errors: {
          dimensions:
            "Il tuo logo è più piccolo di 220x220 px. Prova con un'immagine più grande",
          general: 'Hmm, si è verificato un errore. Riprova',
          size: 'Il tuo logo è più grande di 5 MB. Prova con un file più piccolo',
          type: "Il tuo logo non è in formato JPEG, GIF o PNG. Prova con un'immagine differente",
        },
        instructions:
          "Il tuo logo non può essere più grande di 5 MB. I formati JPEG e GIF vanno bene, ma quello PNG con sfondo trasparente è l'ideale",
        'instructions-title': 'Sfoggia il tuo brand',
      },
      name_modal: {
        content_label: 'Nomina o rinomina il tuo progetto',
        input_placeholder_0: 'Vincerà sicuramente un premio a Cannes',
        input_placeholder_1: 'Una cura per il banale raffreddore',
        input_placeholder_2: 'Il delitto perfetto',
        input_placeholder_3: 'Scrivo canzoni, non titoli',
        input_placeholder_4: 'Idea pluripremiata',
        input_placeholder_5: 'Campagna del brand nuova di zecca',
        input_placeholder_6: 'Dominio globale',
        save: 'Salva',
        text: 'Descrivi su cosa stai lavorando.',
        title: 'Nomina il progetto',
      },
      new_project_label: 'Avvia nuovo progetto',
      noticebar: {
        'button-cancel': 'Annulla',
        'button-clear-all-files': 'Elimina tutto',
        'button-close': 'Chiudi',
        'button-delete': 'Elimina',
        'button-no': 'No',
        'button-share': 'Condividi',
        'button-yes': 'Sì',
        'confirm-cancel': 'Vuoi annullare questo trasferimento?',
        'confirm-clear-files-deliverable':
          'Elimina tutti i file da <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Caricamento completato! Comunica a tutti che hai aggiunto ulteriori file.',
        'confirm-delete-deliverable':
          'Vuoi eliminare <strong><u>%{deliverableName}</u></strong> e tutti i file che hai caricato?',
        'confirm-first-complete':
          'Caricamento completato! Condividi questo progetto per consentire il download dei tuoi file.',
        deliverable_not_found_error:
          'Hmm, sembra che il prodotto finale sia stato eliminato',
        general_error: 'Accidenti, si è verificato un errore! Riprova.',
      },
      'onboarding-promise': {
        description:
          'Illustra tutto il lavoro che realizzerai per un progetto e semplificane la condivisione. Crea un elenco di prodotti finali, quindi aggiungi i file via via che procedi e… niente più link differenti per il download!',
        title: 'Parti con il piede giusto e continua allo stesso modo',
      },
      onboarding: {
        banner:
          'Attenzione! Sei uno dei pochi autorizzati ad accedere alla funzionalità Projects mentre è ancora in fase di realizzazione (e di costante miglioramento). Potremmo contattarti e richiederti un feedback.',
      },
      pagename: 'Projects',
      placeholders: {
        description: 'Fornisci una breve descrizione del progetto',
        loading: 'Caricamento…',
      },
      project: {
        notification: {
          name_saved: 'Nome salvato! Il tuo progetto sembra vincente.',
        },
      },
      share_button_label: 'Condividi',
      unnamed_project_title: 'Progetto senza nome',
      watch_video: 'Guarda il video',
    },
    transfer: {
      display_name_fallback: 'Trasferimento senza titolo',
      does_not_expire: 'nessuna <u>data di scadenza</u>',
      expires_in: 'Scade tra <span>%{time}</span>',
      downloaded_at: 'Scaricato in data %{date}, alle %{time}',
      not_downloaded: 'Non ancora scaricato',
      email_bounced:
        "Mmm, l'indirizzo e-mail a cui hai inviato questo file non funziona",
      count_files: {
        one: '%{count} file',
        other: '%{count} file',
      },
      sent_datetime: 'Inviato in data %{date} alle %{time}',
      never_expires: 'Nessuna data di scadenza',
      and_more: 'Aggiungi altri %{count}',
      read_more: 'di più',
      copy_link: 'copia link',
      message: 'Messaggio',
      total_downloads: 'Download totali',
      sent_to_recipients: {
        one: 'Invia a %{count} persona',
        other: 'Invia a %{count} persone',
      },
      no_transfers: 'Tutti i trasferimenti che invii saranno visualizzati qui',
      add_first_description:
        'Controlla lo stato del download oppure modifica, inoltra o elimina il trasferimento',
      mobile: {
        download: 'Scarica tutti i file',
        remove: 'Elimina trasferimento',
      },
      delete_datetime: 'File eliminati il %{date} alle %{time}',
      detail: {
        plus_download_stats:
          'Ottieni Pro per tenere traccia di quante volte viene effettuato il download dei tuoi trasferimenti.',
        plus_password_expiration:
          'Ottieni Pro per impostare password e date di scadenza per i tuoi trasferimenti.',
        plus_transfer_actions:
          'Ottieni Pro per gestire i tuoi trasferimenti ed eliminarli quando vuoi.',
        title: 'I dettagli del tuo trasferimento',
      },
      download_status_email: '%{count} persone su %{total}',
      download_status_email_text: {
        zero: 'Non ancora scaricato',
        one: '%{count} persone su %{total}',
        other: '%{count} persone su %{total}',
      },
      download_status_link: {
        one: 'Una volta',
        other: '%{count} volte',
      },
      download_status_link_text: {
        zero: 'Non ancora scaricato',
        one: '1 volta',
        other: '%{count} volte',
      },
      sent_moment: 'Inviato il %{moment}',
      total_downloads_tooltip:
        'Non è quello che ti aspettavi? Di recente, abbiamo apportato una piccola modifica. Questo numero mostra solo i download completati.',
      display_name: {
        label: 'Titolo',
        label_mobile:
          "Aggiungi un titolo in modo che sia chiaro cosa c'è nel trasferimento",
      },
      download_status_received_text: {
        zero: 'Non ancora scaricato',
        one: 'Scaricato',
        other: 'Scaricati',
      },
      edit_display_name: {
        cancel: 'Annulla',
        save: 'Salva',
        title: 'Titolo',
      },
      received_datetime: 'Ricevuto in data %{date} alle %{time}',
      received_from: 'Ricevuti da',
      received_moment: 'Ricevuto il %{moment}',
      teams: {
        received_by: 'Ricevuto da',
        self: 'io',
        sent_by: 'Inviato da',
      },
      title: 'Titolo',
      set_password: {
        added: 'Aggiunta',
        change: 'Modifica',
        remove: 'Rimuovi',
        description:
          'Imposta una password per controllare chi ha accesso a questo trasferimento.',
        remove_warning:
          'Vuoi rimuovere la protezione con password da questo trasferimento?',
        yes_remove: 'Sì, rimuovi',
      },
      set_expiration: {
        description:
          "Imposta una data di scadenza per limitare l'accesso a questo trasferimento.",
        label: 'Scade fra',
      },
      anon_upsell_no_account:
        'Per modificare o monitorare i download di questo trasferimento prima della sua scadenza, <a href="%{href}">registrati</a> gratuitamente.',
      anon_upsell_found_account:
        'Per modificare o monitorare i download di questo trasferimento prima della sua scadenza, <a href="%{href}">accedi</a>.',
      anon_upsell_no_account_with_button:
        'Puoi modificare questo trasferimento prima della scadenza creando un account.',
      create_free_account: 'Crea un account gratuito',
    },
    transfers: {
      space_used_unlimited: ' %{space} di storage utilizzato',
      pagename: 'Trasferimenti',
      search: 'Cerca per nome del file',
      search_results: {
        one: '%{count} risultato della ricerca',
        other: '%{count} risultati di ricerca',
        none: 'Nessun risultato',
        retry:
          'Sembra che non siamo riusciti a trovare un trasferimento che corrisponda alla tua ricerca... Fai un altro tentativo.',
      },
      space_used: '%{space} di %{totalSpace} utilizzati',
      selected_text: {
        one: '%{count} trasferimento selezionato (%{size})',
        other: '%{count} trasferimenti selezionati (%{size})',
      },
      last_7_days: 'Inviato negli ultimi 7 giorni',
      over_7_days: 'Inviato più di 7 giorni fa',
      sort_on: 'Ordina per:',
      size: 'Dimensioni',
      name: 'Nome',
      date: 'Data',
      delete: 'Elimina',
      download: 'Scarica',
      forward: 'Inoltra',
      remove: 'Elimina',
      select: 'Seleziona',
      copy_link: 'Copia link',
      sent_time_ago: 'Inviato %{timeAgo} fa',
      files: {
        one: '%{count} file',
        other: '%{count} file',
      },
      confirm_transfer_delete:
        'Aspetta! Sei sicuro di voler eliminare questo trasferimento?',
      confirm_forward:
        'Questo inoltro sostituirà il trasferimento in corso. Vuoi continuare?',
      confirm_expired_transfer_delete:
        'Sei sicuro di voler eliminare per sempre questi file e tutte le informazioni relative a questo trasferimento?',
      deleting_now: 'Stiamo cancellando questo per te',
      deselect_all_transfers: {
        one: 'Deseleziona tutti i trasferimenti',
        other: 'Deseleziona tutti i %{count} trasferimenti',
      },
      downloads: 'Download',
      expiration: 'Data di scadenza',
      expiration_next: 'Scade tra %{days}',
      expiration_no_date: 'Senza data di scadenza',
      expiration_not_soon: 'Non scade a breve',
      include_archived_switch_label:
        'Includi le informazioni per i trasferimenti eliminati',
      include_archived_switch_tooltip:
        'Non contano in relazione al tuo limite di archiviazione',
      notify_completed:
        'Trasferimento completato. Puoi chiudere questo schermo. O puoi continuare a guardarlo, come vuoi.',
      preview: 'Anteprima',
      remove_permanently: 'Elimina queste informazioni per sempre',
      search_placeholder: 'Cerca per nome del file o per indirizzo e-mail',
      select_all_transfers: {
        one: 'Seleziona tutti i trasferimenti',
        other: 'Seleziona tutti i %{count} trasferimenti',
      },
      space_left: '%{space} su %{totalSpace} ancora disponibile',
      teams_tip: {
        subtitle:
          'In questa pagina trovi le tue attività di trasferimento. Nel caso te lo stessi chiedendo: sì, anche gli altri membri del team possono vedere solo i loro trasferimenti.',
        title: 'Il tuo team Pro sta crescendo…',
      },
      title: 'Trasferimenti inviati',
      view_details: 'Vedi i dettagli',
      edit_display_name: 'Modifica il titolo',
      received_time_ago: 'Ricevuti %{timeAgo} fa',
      search_title_placeholder: 'Cerca per titolo, nome del file o e-mail',
      see_all: 'Vedi tutto (%{count})',
      sender: 'Mittente',
      sort_by_title: 'Titolo',
    },
    accountinfo: {
      pagename: "Informazioni sull'account",
      signed_in_as: 'Loggato come %{name}',
      sign_out: 'Esci',
      paid_on: 'Pagato il',
      no_invoices:
        'Le tue ricevute saranno visualizzate qui, ma sembra che tu non ne abbia ancora. Che fortuna!',
      subscription_info:
        'La tua iscrizione a Pro di %{deal} sarà rinnovata automaticamente in data %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          'Ottimo! Ora potrai usufruire di WeTransfer Pro per un intero mese.',
        monthly_renewal:
          'Ottimo! Ora potrai usufruire di Pro per un altro mese.',
        yearly:
          'Ottimo! Ora potrai usufruire di WeTransfer Pro per un intero anno.',
        yearly_renewal:
          'Ottimo! Ora potrai usufruire di WeTransfer Pro per un altro anno.',
      },
    },
    changepassword: {
      pagename: 'Modifica password',
    },
    invoices: {
      pagename: 'Ricevute',
    },
    reviewbilling: {
      pagename: 'Conferma i dati del pagamento',
      information:
        'Per cambiare il tuo metodo di pagamento, dovremo rinnovare contemporaneamente la tua iscrizione',
      information_payment:
        'Ti saranno addebitati %{deal} per il prossimo %{period} di iscrizione a Pro – la tua iscrizione sarà valida fino al %{expiry}',
    },
    renewbilling: {
      pagename: 'Controlla i tuoi dati e rinnova',
    },
    link_downloads_unsubscribe: {
      body: "Puoi annullare l'iscrizione alle notifiche relative ai download effettuati dal link di trasferimento. Potrai sempre tenere traccia dei download nella tua schermata dei Trasferimenti inviati.",
      cta: 'Vai ai miei Trasferimenti inviati',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Scegli dalla galleria',
        },
        next_button: 'Tutto impostato',
        description:
          'Scegli uno sfondo e decidi come appariranno il tuo profilo e le tue pagine di download. Puoi caricare immagini che hai già oppure puoi scegliere tra le nostre opzioni.',
      },
      upload_wallpaper: {
        add_text: "Carica un'immagine",
        add_description:
          "Per risultati ottimali, consigliamo di caricare un'immagine con risoluzione 2560 x 1600 pixel. Le dimensioni massime del file sono 3MB.",
        upload_text: "Carica un'immagine o un video",
      },
      preview: {
        wallpaper_credits_prefix: 'Lo sfondo è stato realizzato da',
      },
      1: {
        description:
          '&quot;Personalizza quello che le persone vedono ogni volta che invii dei file. Non solo: con la tua pagina WeTransfer, chiunque potrà inviarti fino a %{transfer_limit} trasferimenti… ti basterà fornire il tuo URL. Il tuo indirizzo e-mail sarà visibile sulla pagina, così tutti sapranno con certezza che i loro file saranno inviati proprio a te.<br /><br />\nPer cominciare, scegli il tuo URL.&quot;',
        next: 'Avanti',
        skip: 'Salta',
        warning:
          "<strong> Attenzione:</strong> potrai impostarlo una sola volta (tanto per metterti un po' d'ansia!)",
        'blurb-1':
          'Crea la tua pagina WeTransfer in modo che risulti professionale ogni volta che qualcuno scarica i tuoi file e per semplificare (ancora di più) la vita a chi ti vuole inviare trasferimenti.',
        'blurb-2': 'Per cominciare, scegli un URL.',
        welcome: 'Getta le basi con la tua pagina WeTransfer',
        information:
          'Non preoccuparti, puoi sempre modificarlo in un secondo momento in <strong>Branding</strong>.',
        description_unlimited:
          'Personalizza ciò che si vede ogni volta che invii dei file. Con la tua pagina WeTransfer personale chiunque può inviarti trasferimenti di qualsiasi dimensione—dovrai solo condividere il tuo URL. Il tuo indirizzo e-mail sarà disponibile sulla pagina per rassicurare chiunque voglia inviarti qualcosa, che i loro file saranno inviati proprio a te.<br /><br />\nPer prima cosa, scegli il tuo URL.',
      },
      2: {
        description:
          'Puoi selezionare fino a cinque diversi sfondi (o wallpaper, come li chiamiamo noi) per il tuo profilo.\n\nMetti te stesso o il tuo brand al centro di tutto e consegna i file con uno stile tutto tuo',
        pick: 'Scegli dalla nostra galleria',
        title: 'Fai colpo a ogni trasferimento',
        upload: 'Caricane uno tuo',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> è pronto. Ora puoi aggiungere questo link al tuo sito web per permettere agli altri di inviarti trasferimenti fino a %{transfer_limit} o… per inviarli a loro.',
        done: 'Fatto',
        title: 'Che profilo strabiliante',
        description_unlimited:
          '<strong>%{customLink}</strong> è pronto. Ora puoi aggiungere questo link al tuo sito web per chiunque voglia inviarti trasferimenti di qualsiasi dimensione—oppure puoi pensarci tu, eh... A inviare cose.',
      },
    },
    contact: {
      add_contact: 'Aggiungi contatto',
      add_first_description:
        'Salveremo qui anche gli indirizzi e-mail a cui spedisci dei file',
      add_to_transfer: 'Aggiungi al trasferimento',
      remove_from_transfer: 'Rimuovi dal trasferimento',
      confirm_delete: {
        one: 'Sei sicuro di voler eliminare questo contatto?',
        other: 'Sei sicuro di voler eliminare %{count} contatti?',
      },
      contact_count: {
        one: '%{count} contatto',
        other: '%{count} contatti',
      },
      edit: 'Modifica',
      mobile: {
        add: 'Aggiungi contatto',
      },
      no_contacts: 'Aggiungi il tuo primo contatto!',
      pagename: 'Contatti',
      remove: 'Elimina',
      search_count: {
        one: '%{count} risultato della ricerca',
        other: '%{count} risultati della ricerca',
      },
      search_placeholder: 'cerca per e-mail, nome o azienda',
      select: 'Seleziona',
      selected_text: {
        one: '%{count} contatto selezionato',
        other: '%{count} contatti selezionati',
      },
      teams_tip: {
        subtitle:
          'Quando invii qualcosa a qualcuno, lo aggiungeremo direttamente alla tua lista dei contatti. Ogni membro potrà avere una sua lista personale.',
        title: 'Il tuo team Pro sta crescendo…',
      },
    },
    unsubscribeexpiration: {
      button: 'Annulla iscrizione',
      button_unsubscribed: 'Torna a WeTransfer',
      description:
        'Ti mandiamo troppe e-mail? Nessun problema, possiamo smettere di informarti ogni volta che un trasferimento è in scadenza.',
      description_unsubscribed:
        'Non riceverai più e-mail relative ai trasferimenti in scadenza',
      no_email: 'tu',
      title: "Annulla l'iscrizione alle e-mail promemoria",
      title_unsubscribed: 'Tutto fatto!',
      downloaded: {
        body: "Capito. Puoi annullare l'iscrizione ai promemoria relativi ai trasferimenti che stanno per scadere quando i tuoi file sono già stati scaricati. Ciò non cambierà il fatto che potremo ancora inviarti e-mail di promemoria nel caso in cui i tuoi file non siano stati scaricati.",
        cta: "Annulla l'iscrizione",
        title:
          '“I miei file sono stati scaricati. Non mi serve ricevere le e-mail sui trasferimenti in scadenza"',
      },
      not_downloaded: {
        body: "Nessun problema. Puoi annullare l'iscrizione ai promemoria relativi ai trasferimenti che stanno per scadere anche se i tuoi file non sono ancora stati scaricati.",
        cta: "Annulla l'iscrizione",
        title: 'Non ti serve ricevere le e-mail sui trasferimenti in scadenza?',
      },
      pro: {
        body_1:
          "Non fa niente, puoi sempre annullare l'iscrizione a questi promemoria. Nei dettagli del trasferimento, potrai ancora tenere traccia della scadenza e modificare la data di scadenza, quando vuoi.",
        body_2:
          'Psst, se cambi idea o se c\'è qualcosa che non ti quadra puoi sempre farci un fischio all\'indirizzo <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> — nessun rancore.',
        cta: "Annulla l'iscrizione",
        title: 'Non ti serve ricevere le e-mail sui trasferimenti in scadenza?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Vuoi davvero eliminare i cookie?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: "Effettua oggi l'upgrade a Pro per %{price}%{currency}/mese",
      },
    },
    advertise: {
      gallery: {
        preview: 'Anteprima',
      },
      guidelines: {
        advert_static: {
          title: 'Sfondo statico',
        },
      },
    },
    billinginfo: {
      pagename: 'Dati di fatturazione',
    },
    help: {
      button_all_answers: 'Più risposte',
      page_title: 'Aiuto rapido',
      read_more: 'Per saperne di più',
      search_button: 'Cerca',
      search_placeholder: 'Come possiamo aiutarti?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Caricamento...',
    },
    payment_update: {
      bancontact: {
        info: "Attenzione: per verificare che i tuoi dati siano corretti, Bancontact ti addebiterà l'importo una tantum di 0,50€",
      },
      confirm_update: 'Conferma',
      ideal: {
        info: "Attenzione: per verificare che i tuoi dati siano corretti, iDEAL ti addebiterà l'importo una tantum di 0,01€",
      },
      info: "Attenzione: per controllare che i tuoi dati siano corretti, iDEAL ti addebiterà l'importo una tantum di €0,01",
      sofort: {
        info: "Attenzione: per verificare che i tuoi dati siano corretti, SOFORT ti addebiterà l'importo una tantum di 1€",
      },
      title: 'Aggiornamento dati di pagamento',
      update_in_progress: 'Stiamo aggiornando i tuoi dati...',
    },
    sign_in: {
      account: 'Non hai ancora un account?',
      upgrade: "Effettua l'upgrade a WeTransfer Pro",
    },
    signin: {
      account_cta: 'Crea un account',
      account_item_1: 'Invia fino a %{size_limit}',
      account_item_2: 'Gestisci i trasferimenti',
      account_item_3: 'Salva fino a %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Ottieni WeTransfer Pro',
      plus_item_1: 'Invia fino a %{size_limit}',
      plus_item_2: 'Gestisci i trasferimenti',
      plus_item_3: 'Salva fino a %{storage_limit}',
      plus_item_4: 'I tuoi sfondi personali',
      plus_item_5: 'Un URL su misura',
      plus_item_6: 'Proteggi i trasferimenti con una password',
      plus_month: '/mese',
    },
    teams: {
      invitee: {
        action_cancel_invite: "Annulla l'invito",
      },
      invitees: {
        title: 'Invitati - in attesa di risposta',
      },
      member: {
        action_demote: 'Rimuovi dal ruolo di amministratore',
        action_promote: 'Rendi amministratore',
        action_revoke: 'Togli dal team',
      },
      members: {
        title: 'I membri del tuo team',
      },
      no_access: {
        description: 'Stay tuned! Ti faremo sapere quando è pronta. ',
        title: 'Ops, pare che questa funzione sia ancora top secret. ',
      },
      subtitle: {
        members: {
          one: '%{count} membro',
          other: '%{count} membri',
        },
        pending: '%{pendingCount} invitati',
      },
      tip: {
        button: 'Maggiori informazioni',
        subtitle:
          'Con la nostra nuovissima funzione Pro per i team, siamo riusciti a rendere la nostra esperienza WeTransfer ancora migliore! Aggiungi nuovi membri gratuitamente. Utilizza il semplicissimo modulo qui sotto per creare il tuo team - una volta che avranno accettato il tuo invito, sarete pronti per iniziare!',
        title: "Non c'è nessuno in questo team...",
      },
      title: 'Team',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Scade tra %{expiry}',
      },
      recipients: 'Invio a',
      upsell: {
        benefit_one: 'Controlla quando sono stati scaricati i tuoi file',
        benefit_three: 'Verifica e invia di nuovo i tuoi vecchi trasferimenti',
        benefit_two: 'Controlla chi ha scaricato i tuoi file',
        button: {
          action: 'Voglio saperne di più',
          cancel: 'No, grazie',
        },
        heading:
          'Gestisci con facilità i tuoi trasferimenti con WeTransfer Pro',
        title: 'I dettagli del tuo trasferimento',
      },
    },
    transferReceived: {
      'empty-description':
        'Qui troverai tutti i trasferimenti che hai ricevuto. Non ti preoccupare, non occuperanno spazio prezioso',
      'empty-title': "Tieni d'occhio i trasferimenti",
      empty: {
        description:
          'Qui troverai tutti i trasferimenti inviati al tuo indirizzo e-mail o caricati per te. Non ti preoccupare, non occuperanno spazio prezioso.',
      },
      banner: {
        freeUser: {
          text: "Effettua l'upgrade per ricevere in modo semplice. Ottieni un URL personalizzato <strong>iltuonome.wetransfer.com</strong> e una pagina in linea con il tuo brand per i caricamenti.",
          link: 'Scopri di più',
          cta: "Effettua l'upgrade",
        },
        paidUser: {
          withUrl: {
            text: "Chiunque può inviarti 200 GB di trasferimenti all'URL <strong>%{personalisedUrl}</strong>",
            cta: 'Copia URL',
          },
          withoutUrl: {
            text: 'Imposta il tuo URL <strong>iltuonome.wetransfer.com</strong> e chiunque potrà caricarvi dei file.',
            link: 'Scopri di più',
            cta: 'Vai al branding',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: "Annulla l'iscrizione",
      back: 'Torna su WeTransfer',
      contact:
        'Psst, se c\'è qualcosa che non ti quadra, facci un fischio all\'indirizzo <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> — nessun rancore.',
      done: 'Fatto!',
      message:
        'Puoi disiscriverti dalle nostre e-mail introduttive. Non preoccuparti: continuerai a ricevere le comunicazioni importanti.',
      title: 'Hai la posta in arrivo piena?',
    },
    userinfo: {
      pagename: 'Dettagli personali',
    },
    free_onboarding: {
      close: 'Chiudi',
      finish_tour: 'Fatto',
      next: 'Avanti',
      send_files: "Passa direttamente all'invio dei file",
      start_tour: "Guarda cos'altro abbiamo per te",
      step_one: {
        body_1:
          'Ora che hai verificato il tuo indirizzo e-mail, non avrai più bisogno di farlo ad ogni nuovo trasferimento. Niente più codici di verifica!',
        body_2:
          'Tieni traccia di tutti i tuoi trasferimenti in entrata e in uscita, in un unico luogo. Controlla quante volte vengono scaricati i tuoi file. Invia di nuovo, inoltra o cancella i tuoi trasferimenti con un clic.',
        header_1: 'Verificato una volta per tutte',
        header_2: 'Gestisci i tuoi trasferimenti',
        subtitle:
          'Niente più codici di verifica e link per il download perduti. Il tuo nuovo account ti offre il modo più semplice per inviare file di grandi dimensioni, gratuitamente.',
        title_1: 'Invia file <strong>a modo tuo</strong>',
        title_2: 'con WeTransfer',
      },
      step_three: {
        body_1:
          "Che sia un video sul telefono o un link sul desktop, salva tutto ciò da cui trai l'ispirazione in un unico luogo. Per iniziare, apri Collect con l'applicazione di lancio (è quella cosa nell'angolo in alto a sinistra) o usa il link qui di seguito.",
        cta: 'Vai su Collect',
        title_1: '<strong>Salva ciò che ti ispira</strong> on the go',
        title_2: 'con Collect',
      },
      step_two: {
        body_1:
          "Presenta le tue idee, mostra i tuoi lavori ancora in corso e resta sincronizzato, senza dover mai più formattare neanche una slide. Per iniziare, apri Paste con l'applicazione di lancio (è quella cosa nell'angolo in alto a sinistra) o usa il link qui di seguito.",
        cta: 'Vai su Paste',
        title_1: 'Crea <strong>slide nel giro di pochi secondi</strong>',
        title_2: 'con Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Prova i nostri portali',
        pill: 'Una funzione nuova di zecca',
        text: "Ti presentiamo i nostri <strong>portali</strong>, un modo più semplice per ottenere l'ok di cui avevi bisogno. Invita i tuoi clienti e collaboratori a visualizzare i file e a scegliere ciò che preferiscono—senza bisogno di scaricare nulla.",
        title:
          'Condividi il tuo lavoro. Ottieni feedback. Tutto in un unico luogo.',
      },
    },
    not_found: {
      body: 'Torna su <a href="https://wetransfer.com/">wetransfer.com</a> o tirati su di morale leggendo queste <a href="https://wepresent.wetransfer.com/">belle cose che abbiamo scritto</a>.',
      image_alt: 'Si è verificato un errore',
      title: 'Accidenti, non riusciamo a trovare questa pagina!',
    },
    password_and_security: {
      title: 'Password e sicurezza',
      'two-factor-authentication': {
        description: {
          enabled: 'Dal %{date}',
        },
        disable: 'Disattiva',
        done: 'Fatto',
        enable: 'Attiva',
        get_recovery_codes: 'Ottieni i codici di recupero',
        next_step: 'Avanti',
        recovery_code_action: 'Genera nuovi codici',
        recovery_code_keep_safe:
          'Ogni codice può essere utilizzato una volta sola, ma potrai sempre ottenerne degli altri se ne avrai bisogno.',
        recovery_code_need_more:
          'Ti servono altri codici di recupero? Puoi sempre generarne di nuovi, ma ricorda che questo annullerà tutti i codici attualmente validi.',
        recovery_code_title: 'I tuoi codici di recupero',
        require_password_action: 'Accedi',
        require_password_text: 'Inserisci la tua password per continuare',
        step_one_action: {
          app_store: "Scarica dall'App Store",
          google_play: 'Ottieni su Google Play',
        },
        step_one_label: 'Fase 1 (di 3)',
        step_one_text:
          "Avrai bisogno di un'app di autenticazione sul tuo telefono. Se hai già Google Authenticator (o un'altra app), clicca su Avanti.",
        step_one_title: 'Scarica Google Authenticator',
        step_three_label: 'Fase 3 (è tutto pronto!)',
        step_three_text:
          'Se devi effettuare il login e non hai con te il telefono (ci dicono che può davvero accadere), puoi utilizzare uno di questi codici di recupero. Non salveremo questi codici da nessuna parte e non te li mostreremo una seconda volta, quindi segnateli ora e tienili al sicuro come se fossero il codice di sicurezza per accedere al tuo conto in banca.',
        step_three_text_2:
          'Conserva questi codici come fossero la password per accedere al tuo conto in banca! Ogni codice può essere utilizzato solo una volta.',
        step_three_title: 'Salva i codici di recupero',
        step_two_form: {
          error: 'Oh oh, quel codice è sbagliato o scaduto',
          label: 'Codice di verifica',
        },
        step_two_label: 'Fase 2 (siamo a metà strada)',
        step_two_text:
          "Usa la tua app di autenticazione per scansionare questo codice QR. L'app genererà un codice di verifica a sei cifre; inseriscilo qui sotto.",
        step_two_text_mobile:
          "Inserisci questa chiave nella tua app di autenticazione. L'app genererà un codice di verifica a sei cifre; inseriscilo qui sotto.",
        step_two_title: 'Scansiona il codice QR',
        step_two_title_mobile: 'Inserisci la chiave',
        text: {
          protect_account:
            'Usa il tuo telefono per aggiungere un livello di sicurezza in più al tuo account.',
        },
        title: 'Autenticazione a due fattori',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Sfruttare al meglio Paste® e Collect',
      },
      cta: 'No, voglio continuare a usare Pro',
      'cta-2': 'Annulla la mia iscrizione',
      disclaimer: {
        collect:
          'Il tuo spazio di archiviazione in Collect passerà da 200 GB a 5 GB',
        paste:
          'Passerai da un numero illimitato di slide a solo 3 presentazioni in Paste®',
        'team-member': 'Verrai rimosso da %{currentTeam} su WeTransfer Pro.',
        teams:
          'Il tuo team composto da %{amountOfMembers} membri sarà rimosso da %{currentTeam} su WeTransfer Pro',
        title:
          'Al termine della tua attuale iscrizione il <strong>%{date}</strong>:',
        'transfer-expiry':
          'I tuoi trasferimenti esistenti saranno cancellati dopo 28 giorni',
        'transfer-team-member':
          'Non potrai più inviare e ricevere trasferimenti come membro del team e non avrai più la possibilità di gestire i trasferimenti esistenti del team.',
      },
      'password-expiry': {
        title:
          'Proteggere i trasferimenti con password e decidere quando scadono',
      },
      personalization: {
        title: 'Personalizzare la tua pagina WeTransfer personale',
      },
      portals: {
        text: 'Con %{planName}, puoi utilizzare i <a href="%{href}" target="_blank">portali</a> per condividere il lavoro con i clienti e consentire loro di inserire le revisioni… il tutto senza bisogno di nessun download.',
        title: 'Condividere il lavoro e ottenere feedback, in un unico luogo',
      },
      'stay-pro': "Mantieni l'abbonamento",
      'storage-limit': {
        title: 'Goderti %{storage_limit_pro} di storage per persona',
      },
      subtitle:
        'Se cancelli ora la tua iscrizione, a partire dal %{date} non potrai più:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Invita i membri del team</a> a inviare, ricevere e gestire i trasferimenti insieme… o lavora da solo gratis.',
        'team-member-text':
          'Verrai rimosso dal tuo team e non potrai più inviare, ricevere o gestire i trasferimenti insieme agli altri membri.',
        'team-owner-text':
          '<a href="%{href}" target="_blank">%{amountOfMembers} membri del tuo team</a> non potranno più inviare, ricevere o gestire i trasferimenti in comune.',
        title: 'Lavorare sulle tue grandi idee con il tuo team',
      },
      title: 'Vuoi davvero rinunciare a %{planName}?',
      'transfer-limit': {
        text: 'Ora puoi inviare e ricevere trasferimenti più grandi… ben più grandi rispetto ai %{transfer_limit_free} gratuiti.',
        title: 'Inviare trasferimenti 100 volte più grandi',
      },
      'transfer-unlimited': {
        text: 'Puoi inviare (e ricevere) trasferimenti senza limiti nella dimensione dei file—infinitamente di più rispetto ai %{transfer_limit_free} gratuiti.',
        title: 'Inviare trasferimenti di qualsiasi dimensione',
      },
    },
    pricing: {
      pro: {
        per_person: 'per persona',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Crea un account',
        current_plan: 'Piano attuale',
        sign_up: 'Iscriviti',
        switch_premium: 'Passa a Premium',
        switch_pro: 'Passa a Pro',
        upgrade: "Fai l'upgrade",
      },
      faq: {
        answers: {
          answer_1:
            "Potrai iniziare a usare WeTransfer Pro o WeTransfer Premium non appena avrai completato il tuo pagamento. Ti invieremo anche un'e-mail di conferma con la fattura pagata in allegato. <br /><br /> \n \nUna volta eseguito l'accesso, potrai subito inviare trasferimenti più grandi, usare i portali e creare una pagina WeTransfer tutta tua. Se sono presenti trasferimenti inviati quando ancora usavi il piano gratuito, potrai cambiare anche la loro scadenza, specificando una data a tua scelta.",
          answer_2:
            "Quando usi WeTransfer, chiunque può scaricare i tuoi file—i destinatari non devono accedere o registrarsi. Dovranno accettare i nostri Termini di servizio e forse anche i cookie, ma solo quello! <br /><br /> \n \nSe vuoi condividere il lavoro o collaborare nei portali (l'ultima funzionalità introdotta da WeTransfer), i tuoi clienti e collaboratori non avranno bisogno di iscriversi per visualizzare e selezionare i file, aggiungere commenti e approvare o scaricare i file. Se vuoi permettere ai membri del tuo team di aggiungere revisioni e creare portali con te, non dovrai fare altro che aggiungerli al tuo piano Pro o Premium.",
          answer_3:
            "Con un piano Pro o Premium, puoi creare una pagina WeTransfer tutta tua dalla quale chiunque potrà inviarti file con il limite di dimensione dei trasferimenti previsto dal tuo piano. Ciò significa che potrai ricevere dai tuoi clienti e collaboratori i file di grandi dimensioni che ti servono e loro non dovranno avere un account—solo l'URL della tua pagina. (Però guarda che potremmo chiedere loro di verificare l'indirizzo e-mail per proteggerti da “ricchi stranieri” che “vogliono inviarti del denaro”).",
          answer_4:
            "Per prima cosa dovrai iscriverti a WeTransfer Pro o WeTransfer Premium—non puoi aggiungere membri se stai ancora usando il piano gratuito. Qualsiasi piano tu scelga, anche i membri del tuo team godranno degli stessi vantaggi (per esempio non puoi usare Premium e scegliere Pro per i membri del tuo team). I tuoi membri potranno inviare e ricevere trasferimenti più grandi dalla tua pagina WeTransfer e gestire i trasferimenti da una panoramica condivisa. <br /><br /> \n \nQuando avrai effettuato l'iscrizione al piano migliore per il tuo team, potrai invitare quanti membri vorrai, accedendo alle impostazioni per la gestione del team. Puoi aggiungere e rimuovere membri in qualsiasi momento, per tutto il tempo in cui la tua iscrizione è attiva.",
          answer_5:
            "Accettiamo sia PayPal sia le carte di credito dei principali circuiti di pagamento quali Visa, Mastercard e American Express. In alcuni Paesi sono supportati anche altri sistemi di pagamento online. <br /><br /> \n \nNon accettiamo bonifici bancari diretti poiché l'iscrizione prevede pagamenti ricorrenti su base annuale o mensile. (Ti invieremo un'e-mail prima del primo rinnovo, come forma di preavviso.)",
          answer_6:
            "Se non hai lo spazio di archiviazione illimitato di WeTransfer Premium, dovrai liberare un po' di spazio eliminando alcuni dei tuoi trasferimenti inviati o effettuando l'upgrade del tuo piano. Finché non avrai risolto questa situazione non potrai inviare nuovi trasferimenti. <br /><br /> \n \nSe stai usando WeTransfer gratuitamente, tutti i tuoi trasferimenti fino a 2 GB verranno eliminati dopo 7 giorni. Quindi non preoccuparti, non c'è modo che tu possa superare il limite di spazio di archiviazione.",
          answer_6_variant_asterisk:
            "Dovrai liberare un po' di spazio eliminando alcuni dei trasferimenti inviati o eseguendo l'upgrade del tuo piano. Finché non avrai spazio a sufficienza, non potrai inviare nuovi trasferimenti. <br /><br />\n\nSe hai un'iscrizione Premium e hai già occupato i 5 TB a tua disposizione, puoi contattare il nostro team di assistenza e richiedere di espandere lo storage fino a un limite annuale massimo di 15 TB. <br /><br />\n\nSe stai usando WeTransfer gratuitamente, tutti i trasferimenti inviati fino a 2 GB verranno eliminati automaticamente dopo 7 giorni. Quindi non preoccuparti, non c'è modo che tu possa superare il limite di storage.",
          answer_6_variant_limited_storage:
            "Dovrai liberare un po' di spazio eliminando alcuni dei trasferimenti inviati o eseguendo l'upgrade del tuo piano (a meno che tu non abbia un'iscrizione Premium). Finché non avrai spazio a sufficienza, non potrai inviare nuovi trasferimenti. <br /><br />\n\nSe stai usando WeTransfer gratuitamente, tutti i trasferimenti inviati fino a 2 GB verranno eliminati automaticamente dopo 7 giorni. Quindi non preoccuparti, non c'è modo che tu possa superare il limite di storage.",
          answer_7:
            "La tua iscrizione verrà rinnovata automaticamente (ti invieremo un'e-mail prima che ciò accada per la prima volta), ma puoi annullarla in qualsiasi momento. <br /><br /> \n \nPer passare a usare WeTransfer gratuitamente, tutto ciò che devi fare è andare nelle impostazioni del tuo <strong>Account</strong> e annullare la tua iscrizione. Tu (e qualsiasi membro del team che potresti avere) potrete continuare a usare il tuo piano Pro o Premium fino alla fine dell'attuale periodo di iscrizione.",
          answer_8:
            "Milioni di persone in tutto il mondo si fidano di WeTransfer e della nostra serie di strumenti per far girare le loro idee. Ogni mese, 80 milioni di persone condividono 2 miliardi di file sulla nostra piattaforma di condivisione dei file. <br /><br /> \n \nPer proteggere le tue idee da attacchi o abusi, i tuoi file sono criptati durante il trasferimento (TLS) e l'archiviazione (AES-256). Quando i file vengono archiviati, è possibile accedervi solo utilizzando i link unici inviati al mittente e al destinatario.",
        },
        questions: {
          question_1: 'Cosa succede quando mi iscrivo e pago?',
          question_2: 'Devono iscriversi anche i miei destinatari?',
          question_3: 'Posso ricevere trasferimenti più grandi da chiunque? ',
          question_4:
            'Come posso aggiungere (e rimuovere) i membri dal mio team?',
          question_5: 'Quali metodi di pagamento posso usare?',
          question_6:
            'Cosa succede se supero il limite di spazio di archiviazione a mia disposizione?',
          question_7: 'Come posso annullare la mia iscrizione?',
          question_8: 'Mi posso fidare di WeTransfer? È davvero sicuro?',
        },
        title: 'Domande frequenti',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Pubblicità (e arte)',
            custom: 'Carica il tuo sfondo',
            feature_1: 'Pagina WeTransfer personalizzata',
            feature_2: 'Wallpaper di sfondo',
            feature_3: 'E-mail di WeTransfer personalizzate',
          },
          title: 'Sfoggia il tuo brand',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} di storage',
            title: 'Collect di WeTransfer',
          },
          paste: {
            limited_decks:
              'Fino a %{pasteDecksLimit} slide con il logo di Paste predefinito',
            title: 'Paste® di WeTransfer',
            unlimited_decks: 'Slide illimitate con il tuo branding',
          },
          title: 'Completa il tuo toolkit creativo',
        },
        expiry: 'I trasferimenti scadono dopo %{days} giorni',
        extra_storage: '%{storageLimit} extra per persona',
        monthly_price: '%{price} al mese per persona',
        portals: {
          features: {
            feature_1: 'Portali',
            feature_2: 'Revisioni',
            feature_3: 'Branding del cliente',
          },
          title: 'Condividi il lavoro per ricevere feedback e approvazione',
        },
        security: {
          features: {
            feature_1: 'Date di scadenza personalizzate',
            feature_2: 'Trasferimenti protetti da password',
            feature_3: 'Codifica dei dati',
            feature_4: 'Autenticazione a due fattori',
          },
          title: 'Proteggi i tuoi trasferimenti',
        },
        storage_limit: '%{storageLimit} per persona',
        teams: {
          features: {
            feature_1: 'Invita i membri del team',
            feature_2: 'Panoramica condivisa dei trasferimenti',
            feature_3: 'Storage condiviso',
            feature_4: 'Branding condiviso',
          },
          title: 'Consegna il lavoro con il tuo team',
          subtext: {
            text: "Supportato solo acquistando un'iscrizione dal nostro sito web.",
            learn_more: 'Scopri di più',
          },
        },
        tooltips: {
          tooltip_1:
            'Tutti i trasferimenti che invii occupano spazio nel tuo storage',
          tooltip_10:
            'Puoi inviare o conservare i file in tutta sicurezza con i protocolli di cifratura TLS e AES-256',
          tooltip_11:
            'Tenete traccia dei download e gestite i trasferimenti insieme',
          tooltip_12:
            'Sfoggia il tuo lavoro (di squadra) con sfondi ed e-mail in linea con il tuo brand',
          tooltip_13:
            'Paste è uno strumento per creare presentazioni che progetta slide per te con colori, allineamenti e layout responsivi',
          tooltip_14:
            'Collect ti permette di salvare e organizzare immagini, video, musica e link su tutti i tuoi dispositivi',
          tooltip_2:
            'Chi scarica i tuoi file non ha bisogno di accedere o iscriversi',
          tooltip_3: 'Tieni tracci di chi ha (o non ha) scaricato i tuoi file',
          tooltip_4: 'Organizza il tuo lavoro per cliente e per progetto',
          tooltip_5:
            'Invita i clienti a visualizzare e selezionare i file, aggiungere commenti e approvare il lavoro—senza bisogno di scaricare nulla',
          tooltip_6:
            'Aggiungi un logo e un titolo per personalizzare i tuoi portali per ciascun cliente',
          tooltip_7:
            'La tua pagina WeTransfer è il luogo in cui le persone possono scaricare i tuoi file e inviarti trasferimenti con il limite previsto dal tuo piano',
          tooltip_8:
            'I wallpaper sono i video o le immagini che vedi sullo sfondo quando invii o ricevi file su wetransfer.com',
          tooltip_9:
            'Wow, e noi che pensavamo che nessuno si sarebbe mai messo a leggere queste istruzioni—avevamo torto. Congratulazioni! Gli screenshot potrebbero essere ritwittati su @WeTransfer (o anche no)',
        },
        transfer_classic: {
          features: {
            feature_1: 'Limite nella dimensione dei trasferimenti',
            feature_2: 'Storage',
            feature_3: 'Download senza bisogno di un account',
            feature_4: 'Tracciamento dei download',
            feature_5: 'App iOS',
          },
          title: 'Invia file di grandi dimensioni',
        },
        unlimited: 'Illimitato',
        yearly_price: "%{price} all'anno per persona",
      },
      header: {
        subtitle:
          'Che tu stia inviando grandi file per lavoro o per diletto—continua a far girare i tuoi progetti creativi con WeTransfer.',
        title: {
          english_1: 'Tu ci metti le idee,',
          english_2: 'noi ci mettiamo i piani',
          general: 'Piani e prezzi',
        },
      },
      plans: {
        billing: {
          discount: 'Risparmia il %{percentage} (evvai)',
          discount_up_to: 'Save up to %{percentage} (ooh yeah)',
          monthly: 'Fatturazione mensile',
          yearly: 'Fatturazione annuale',
        },
        free: {
          subtitle: 'Invia file occasionalmente',
          title: 'Gratis',
          usp: {
            feature_1: 'Invia fino a %{transferLimit}',
            feature_2: "Non c'è bisogno di verificare i trasferimenti",
          },
        },
        premium: {
          subtitle: 'Condividi il lavoro senza limiti',
          title: 'Premium',
          usp: {
            feature_1: 'Nessun limite nelle dimensioni dei trasferimenti',
            feature_2: 'Storage illimitato',
            feature_2_subtitle:
              '*Il limite iniziale è di %{storageLimit}, ma puoi richiedere di espandere lo spazio disponibile. Si applica un limite massimo annuale di %{annualStorageLimit}. Per ulteriori informazioni, consulta i nostri <a href="/legal/terms" data-route-type="premium" target="_blank">Termini di servizio</a>.',
            feature_3: 'Portali e revisioni illimitati',
          },
        },
        pro: {
          subtitle: 'Invia regolarmente file di grandi dimensioni',
          title: 'Pro',
          usp: {
            feature_1: 'Invia e ricevi fino a %{transferLimit}',
            feature_2: '%{storageLimit} di storage per persona',
            feature_3: '%{portalsLimit} portale, revisioni illimitate',
          },
        },
        tagline: {
          free: 'nessun costo, nessun problema',
          monthly: 'al mese per persona',
          yearly: "all'anno per persona",
          per_person_monthly: 'a persona, con fatturazione mensile',
          per_person_yearly: 'a persona, con fatturazione annuale',
          tax_included: 'tasse incluse',
        },
        title: 'Scegli il piano che fa per te',
        month: 'mese',
      },
      skip_link: 'Passa a più funzionalità',
    },
    pro_classic: {
      hero: {
        cta_1: 'Scopri di più',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Tu ci metti le idee, noi ci mettiamo il piano giusto',
      },
      cta: 'Voglio solo inviare i miei file',
      free_panel: {
        cta: 'Iscriviti',
      },
      plan: {
        free: {
          feature_1: 'inviare fino a <strong>%{transfer_limit}</strong>',
          feature_2: 'Non c’è bisogno di verificare i trasferimenti',
          subtitle_new: 'Per inviare file occasionalmente',
          title: 'Gratis',
        },
        pro: {
          feature_1: 'Invia e ricevi fino a <strong>%{transfer_limit}</strong>',
          feature_2: 'Decidi tu quando far scadere i trasferimenti',
          feature_5: '1 TB di storage per persona',
          subtitle_new: 'Per team e professionisti',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Registrati ora',
          descripttion: 'Tieni traccia dei trasferimenti',
          feature_1: 'Invia fino a 2 GB',
          feature_2: "Ricevi trasferimenti in un'unica panoramica",
          title: 'Gratis',
        },
        pro: {
          cta: 'Maggiori informazioni',
          descripttion: 'Ottieni il meglio di WeTransfer',
          feature_1: 'Invia e ricevi fino a %{transfer_size}',
          feature_2: '%{storage_size} di storage per trasferimenti a persona',
          feature_3: 'Invia trasferimenti con impostazioni personalizzate',
          title: 'Pro',
        },
        title:
          'Non perdere più i tuoi file nella casella della Posta in arrivo.',
      },
      title: 'Sfrutta al massimo il nuovo WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Invita il team',
        pagename: 'Invita il team',
      },
      manage: {
        cta: 'Gestisci il tuo team',
      },
      members:
        'Hai %{amountOfMembers} membri nel tuo team. <a href="%{href}">%{cta}</a>',
      no_members: 'Per ora ci sei solo tu! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Impostazioni team',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Trasferimenti, insieme',
        context:
          'Invia e ricevi trasferimenti come team con storage e branding condivisi e accesso ai trasferimenti reciproci.',
        invite_team: 'Invita il team',
        dismiss: 'Forse più tardi',
      },
      feature_highlight: {
        free_context:
          'Ora puoi gestire i trasferimenti in entrata e in uscita in una semplice panoramica. Ti avviseremo subito quando qualcuno scarica i tuoi file. Invia di nuovo, inoltra o scarica i tuoi trasferimenti con un clic. Niente di più semplice',
        free_subtitle: 'Tutti i tuoi trasferimenti in un unico luogo',
        paste_collect_link:
          'Accedi a <a href="%{pasteUrl}" rel="external">%{pasteName}</a> o <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Ora puoi inviare trasferimenti di qualsiasi dimensione e creare una <b>pagina WeTransfer</b> tutta tua per personalizzare ciò che le persone vedono quando scaricano i tuoi file. Pronto a scegliere il tuo URL e gli sfondi?',
        premium_cta: 'Crea la tua pagina',
        premium_dismiss: 'Forse più tardi',
        premium_subtitle: 'Configura la tua pagina WeTransfer',
        premium_team_context:
          'Ora puoi inviare e ricevere trasferimenti di qualsiasi dimensione dalla pagina WeTransfer personalizzata del tuo team.',
        pro_context:
          'Ora puoi inviare fino a %{transfer_limit} di trasferimenti alla volta e creare una <b>pagina WeTransfer</b> tutta tua per personalizzare ciò che le persone vedono quando scaricano i tuoi file. Pronto a scegliere il tuo URL e gli sfondi?',
        pro_team_context:
          'Ora puoi inviare e ricevere trasferimenti da %{transfer_limit} dalla <b>pagina WeTransfer personalizzata</b> del tuo team.',
        send_cta: 'Passa ai file inviati',
        team_subtitle: 'Consegna lavori creativi come team',
      },
      marketing: {
        context:
          "Ora che ti conosciamo un po' meglio, vorremmo raccontarti qualcosa in più su di noi. Vuoi ricevere storie di grande creatività e le ultime novità di WeTransfer?",
        image_alt_text:
          'Esempio di contenuto di e-mail, incluse le nuove funzionalità dei prodotti, rapporti di settore e articoli di WePresent che raccontano grandi storie sulla creatività.',
        opt_in: 'Sì, per favore',
        opt_out: 'No, grazie',
        unsubscribe:
          'Puoi sempre disiscriverti in un secondo momento—nessun rancore.',
      },
      welcome: {
        context:
          'Vogliamo conoscerti meglio per poter migliorare il nostro servizio.',
        cta: 'Continua',
        dismiss: 'Salta',
        dropdown_options: {
          architecture: 'Architettura / Edilizia',
          data: 'Dati / Finanza / Legale',
          design: 'Design / Illustrazione',
          education: 'Insegnamento / Formazione',
          marketing: 'Marketing / PR',
          music: 'Musica / Suono',
          other: 'Altro (e me ne vanto)',
          photography: 'Fotografia',
          product: 'Prodotto / Software',
          sales: 'Vendite / Relazioni con il cliente',
          video: 'Video / Animazione',
        },
        free_tier_title: 'Ti diamo il benvenuto in WeTransfer, %{name}!',
        placeholder: 'Mmm, vediamo...',
        question: 'Prima di tutto, in che campo lavori?',
        team_title: 'Sei dei nostri, %{name}!',
        tier_title: 'Ti diamo il benvenuto in WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Consenti a WeTransfer di utilizzare i dati che condividi per mostrarti annunci personalizzati sui nostri siti e su altri siti web.',
          tooltip_anchor: 'Che cosa significa?',
          tooltip: {
            title: 'In che modo WeTransfer utilizza i miei dati?',
            p1: 'Utilizziamo il tuo indirizzo e-mail per mostrarti (e mostrare ad altre persone simili a te) annunci di WeTransfer sui siti web che visiti, ad esempio sui social media.',
            p2: "Utilizziamo inoltre il tuo settore lavorativo per fornirti un'esperienza migliore sui nostri siti web.",
            p3: 'I dati che scegli di condividere con noi rimarranno sempre al sicuro.',
            button: 'Ho capito',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Aggiungi altre persone al tuo spazio di lavoro',
      workspace: 'Spazio di lavoro',
      manage_workspace: 'Gestisci lo spazio di lavoro',
    },
  },
  exception: {
    activate_subscription_exception:
      'Mmm, qualcosa è andato storto. Riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro di assistenza</a>',
    complete_payment_exception:
      'Hmm, qualcosa è andato storto: riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro assistenza</a>',
    retrieve_checkout_exception:
      'Mmm, qualcosa è andato storto. Riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro di assistenza</a>',
    source_id_error:
      'Siamo spiacenti, purtroppo non è stato possibile elaborare questa richiesta. Riprova!',
    three_d_secure: 'Attualmente non supportiamo le carte 3D Secure.',
    something_went_wrong:
      'Mmm, qualcosa è andato storto; riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro di assistenza</a>',
    signin_no_data_exception:
      'Mmm, qualcosa è andato storto; controlla il nome utente e la password e riprova',
    signin_exception:
      'Purtroppo non è stato possibile effettuare il login; riprova',
    signout_exception:
      'Mmm, sembra che non riusciamo a farti uscire. Che strano. Aggiorna la pagina per controllare se sei ancora loggato.',
    signup_account_error:
      'Mmm, qualcosa è andato storto durante la registrazione; controlla i tuoi dati e riprova',
    retrieve_account_exception:
      'Mmm, purtroppo qualcosa è andato storto. Ci dispiace chiedertelo ma... puoi riprovare?',
    update_account_error:
      'Purtroppo non è stato possibile aggiornare i dati del tuo account. Puoi riprovare?',
    retrieve_subscription_exception:
      'Non siamo riusciti a trovare i dati del tuo pagamento; riprova',
    update_subscription_exception:
      'Non è stato possibile aggiornare i dati del tuo pagamento; riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro di assistenza</a>',
    autorenewal_not_supported:
      'Il rinnovo automatico non è supportato per questo account',
    email_background_upload_validation_error:
      "Questo file è troppo grande oppure non è in formato png o jpg - prova con un'immagine diversa",
    email_background_upload_validation_error_videos:
      "Questo file è troppo grande oppure non è in formato png o jpg - prova con un'immagine diversa",
    update_password_exception:
      'Purtroppo non è stato possibile aggiornare la tua password; riprova',
    retrieve_device_exception:
      'Non siamo riusciti a trovare dispositivi collegati, nemmeno uno! Riprova.',
    remove_device_exception:
      'Non è stato possibile rimuovere questo dispositivo',
    renew_subscription_exception:
      'Non è possibile rinnovare il tuo account in questo momento; riprova più tardi',
    invoices_retrieve_exception:
      'Non è stato possibile trovare le tue ricevute; riprova',
    invoice_download_exception:
      'Non è stato possibile scaricare questa ricevuta; riprova',
    image_not_valid:
      'Mmm, sembra che non sia possibile caricare questa immagine',
    update_profile_error:
      'Non è stato possibile aggiornare il tuo profilo; riprova',
    retrieve_profile_exception:
      'Non è stato possibile trovare le impostazioni del tuo profilo; riprova',
    s3_exception:
      'Mmm, qualcosa è andato storto durante il caricamento; riprova',
    file_size_limit_reached:
      "Più grande non vuole sempre dire meglio; carica un'immagine di 3MB al massimo",
    retrieve_transferlist_exception:
      'Non siamo riusciti a trovare la tua lista dei trasferimenti',
    retrieve_transfer_exception:
      'Non è stato possibile trovare i dati dei trasferimenti',
    delete_transfer_exception:
      'Non siamo riusciti a eliminare questo trasferimento',
    delete_transfers_exception:
      'Non siamo riusciti a eliminare questi trasferimenti',
    update_expiry_exception:
      'Non è stato possibile aggiornare questa data di scadenza',
    add_contact_exception: 'Non è stato possibile aggiungere questo contatto',
    complete_last_order_exception:
      'Non è stato possibile completare il tuo ordine',
    edit_contact_exception: 'Non è stato possibile aggiornare questo contatto',
    remove_contact_exception: 'Non è stato possibile eliminare questo contatto',
    request_password_reset_exception:
      'Purtroppo non è stato possibile elaborare questa richiesta di ripristino; riprova',
    request_password_reset_no_user:
      "Non riconosciamo questo indirizzo e-mail! Controlla che l'indirizzo sia corretto e riprova",
    reset_password_error:
      'Qualcosa è andato storto durante il ripristino della password; riprova',
    reset_password_exception:
      'Purtroppo non è stato possibile ripristinare la tua password; riprova',
    reset_password_token_invalid:
      'Questo ripristino non ha funzionato; segui le istruzioni che ti abbiamo inviato per e-mail o ricomincia',
    retrieve_last_order_exception:
      'Non è stato possibile trovare il tuo ordine',
    retrieve_ternot_exception:
      'Mmm, purtroppo abbiamo difficoltà a trovare il tuo trasferimento; riprova',
    signin_invalid_credentials:
      'Questo indirizzo e-mail e la password sembrano non corrispondere; ricontrolla e prova ancora',
    unsubscribe_expiration_exception:
      "Qualcosa non ha funzionato durante l'annullamento dell'iscrizione; riprova",
    unsubscribe_expiration_invalid_signature:
      "Mmm, purtroppo questo link per annullare l'iscrizione non ha funzionato; riprova",
    cancel_subscription_exception:
      'Pare che qualcosa sia andato storto e non siamo riusciti a cancellare la tua sottoscrizione. Riprova più tardi.',
    payment_cancelled:
      'Hmm, si è verificato un errore. Riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro assistenza</a>',
    profile_picture_upload_validation_error:
      "Questo file è troppo grande oppure non è in formato png o jpg - prova con un'immagine diversa",
    reactivate_subscription_exception: 'Qualcosa è andato storto. Riprova',
    retrieve_contactlist_exception:
      'Non siamo riusciti a trovare la tua lista di contatti',
    source_retrieve_error:
      'Hmm, si è verificato un errore. Riprova o contatta il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro assistenza</a>',
    token_error: 'Qualcosa è andato storto. Ti va di riprovare?',
    update_user_error:
      "Si è verificato un problema durante l'aggiornamento dei tuoi dati",
    wallpaper_upload_validation_error:
      "Questo file è troppo grande oppure non è in formato png o jpg - prova con un'immagine diversa",
    wallpaper_upload_validation_error_videos:
      'Oops, pare che il tuo video non soddisfi i nostri requisiti: fai un altro tentativo',
    declined_contact_bank_error:
      'Purtroppo non siamo riusciti a elaborare questo pagamento. Contatta la tua banca',
    invalid_password: 'Password non riconosciuta',
    otp_token_invalid: 'Oh oh, quel codice è sbagliato o scaduto',
    projects_load_exception:
      'Non è attualmente possibile caricare i tuoi progetti',
    update_information_throttle:
      "Si è verificato un problema durante l'aggiornamento dei tuoi dati. Prenditi una pausa di %{throttle_time} prima di riprovare.",
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
    price_general_error_transfer_details:
      'The price could not be updated, please try again',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Prodotti',
        plans_and_pricing: 'Piani e prezzi',
        pricing: 'Prezzi',
        pro_and_premium: 'WeTransfer Pro e Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Pubblicizza',
        upgrade: "Effettua l'upgrade",
      },
      name_1_2019: "L'azienda",
      name: "L'azienda",
    },
    home: {
      name: 'Home',
    },
    help: {
      name: 'Aiuto',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Trasferimenti',
        contacts: 'Contatti',
        profile: 'Profile',
        account: 'Account',
        received: 'Ricevuti',
        sent: 'Inviati',
        teams: 'Il team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Esci',
    signin: {
      name: 'Login',
    },
    branding: 'Branding',
    label: {
      beta: 'Beta',
      new: 'Novità',
    },
    login: 'Accedi',
    logout: 'Esci',
    portals: 'Portali',
    signup: 'Registrati',
    features: {
      name: 'Funzioni',
      all: 'Tutte le funzionalità',
      file_sharing: 'Per la condivisione di file',
      collaboration: 'Per la collaborazione',
      security: 'Per la sicurezza dei dati',
      branding: 'Per il branding',
      fast_feedback: 'Per feedback veloci',
    },
    referral: 'Presentaci i tuoi amici',
    switcher: {
      create_free_account: 'Aggiungi gratuitamente',
      just_you: 'Solo tu',
      team: 'Team',
      team_member_count: '%{amountOfMembers} membri',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, non sei connesso a internet',
        begins_space:
          'Non è possibile inviare file i cui nomi iniziano con uno spazio. Rinomina e riprova.',
        begins_stop:
          'Non è possibile inviare file i cui nomi iniziano con un punto. Rinomina e riprova.',
        blocked:
          'Non è stato possibile caricare WeTransfer – sembra che tu sia stato bloccato',
        generic:
          'Purtroppo qualcosa non ha funzionato durante il trasferimento',
        has_blackslash:
          'Non è possibile inviare file i cui nomi includono una barra inversa. Rinomina e riprova.',
        has_linebreak:
          'Non è possibile inviare file i cui nomi vanno a capo. Rinomina e riprova.',
        incorrect_recipient:
          'Sembra che uno degli indirizzi e-mail che hai inserito non sia corretto',
        incorrect_sender:
          'Sembra che si sia verificato un problema con il tuo indirizzo e-mail',
        io_error: 'Si è verificato un problema con i tuoi file',
        long_filename:
          'Non possiamo inviare file i cui nomi contengono più di 250 caratteri. Rinomina e riprova.',
        long_message: 'Il messaggio è troppo lungo – abbrevialo',
        missing_default_recipient:
          "Puoi inviare più di %{free_transfer_limit} soltanto all'indirizzo e-mail registrato su WeTransfer Pro. Aggiorna la pagina per iniziare di nuovo.",
        no_clipboard: 'Sembra che tu non abbia copiato il link',
        no_files: 'Sembra che tu non abbia ancora aggiunto file!',
        no_folders: 'Devi zippare/comprimere la cartella prima di inviarla',
        no_recipient:
          "Abbiamo bisogno dell'indirizzo e-mail a cui vuoi inviare questi file",
        no_sender:
          'Abbiamo bisogno solo del tuo indirizzo e-mail e siamo pronti',
        too_big:
          'Attenzione – non possiamo trasferire più di %{upload_limit} alla volta',
        too_many_recipient:
          'Ops, %{count} è il nostro numero massimo. Vuoi inviare a più persone? Perché non provi con un trasferimento tramite link?',
        unavailable:
          'Purtroppo questo trasferimento è stato annullato e non è più disponibile',
        wrong_password:
          'Mmm, questa password non è corretta. Riprova o verifica la password con la persona che ti ha inviato questo trasferimento.',
        default_title: 'Ops!',
        duplicate_filename:
          'Non è possibile inviare più file con lo stesso nome. Rinomina i file e riprova.',
        firstaccept: 'Devi approvare, prima di confermare la spedizione',
        not_downloadable:
          "Mmm, si è verificato un errore durante l'elaborazione dei tuoi file. Ricarica la pagina e riprova.",
        recaptcha: {
          text: 'Qualcosa è andato storto. Riprova!',
          title: 'Oh oh...',
        },
        too_big_text:
          'Non puoi trasferire più di %{upload_limit} alla volta. Invia fino a %{plus_limit} con Pro. ',
        too_big_title: 'Ehi trasferisco-tutto-io',
        too_many_files:
          'Non puoi inviare più di %{count} file allo stesso tempo',
        too_many_recipient_text:
          'Con Pro puoi inviare i file a un massimo di 50 persone.',
        too_many_recipient_title: 'Troppa gente',
        unavailable_forward:
          'Purtroppo sembra che questo trasferimento sia stato eliminato, quindi non può essere inoltrato',
        verify: {
          button: 'Datemi un nuovo codice!',
          text: 'Prova di nuovo o richiedi un nuovo codice. ',
          title: 'Ops!',
        },
      },
      buttons: {
        check_out: "Dacci un'occhiata!",
        help: 'Assistenza',
        plus: 'Ottieni Pro',
        get_link: 'Ottieni il link',
      },
      tips: {
        change_type:
          'Invia file per e-mail o crea un link dedicato per il trasferimento che potrai condividere come preferisci',
        contacts:
          'Qualunque destinatario dei tuoi file sarà aggiunto automaticamente ai tuoi contatti',
        expiry:
          'Con WeTransfer Pro decidi tu la scadenza dei tuoi trasferimenti. (Puoi persino modificarla dopo aver inviato il trasferimento!)',
        free_limit:
          'La buona notizia è che puoi inviare fino a %{size} alla volta. La notizia ancora migliore è che puoi usare il servizio ogni volta che vuoi!',
        message:
          'Se vuoi, puoi aggiungere un messaggio al tuo trasferimento qui',
        password:
          "Puoi proteggere un trasferimento con una password per maggiore sicurezza. Tieni presente che noi non inseriamo la password nell'e-mail, quindi sarai tu a doverla comunicare alle persone giuste!",
        recipient_limit:
          'Aggiungi fino a un massimo di %{email_limit} indirizzi e-mail o, in alternativa, apri il menu accanto al pulsante del trasferimento per creare un link',
        transfer_history:
          'Il tuo trasferimento si trova nel riepilogo dei tuoi trasferimenti',
        your_email:
          'Inserisci il tuo indirizzo e-mail qui, così potremo farti sapere quando i tuoi file sono stati scaricati',
        link_transfer:
          'Sai che puoi ottenere il link per il tuo trasferimento direttamente da qui?',
        previews_receiver:
          "Le immagini inviate dagli utenti Pro possono essere visualizzate in anteprima prima di essere scaricate. Basta fare clic su un file per vedere cosa c'è dentro!",
        previews_sender:
          'Ora le immagini che invii possono essere visualizzate in anteprima prima di essere scaricate',
        vrl_text:
          "Ora puoi dare un'occhiata ai tuoi file, senza doverli scaricare.",
        vrl_title: 'I file in anteprima',
        zip_text: 'Vuoi inviare una cartella? Ci pensiamo noi a zippare tutto',
        zip_title: 'Non fare lo zip',
        add_display_name_tooltip:
          'Dai un titolo al tuo trasferimento in modo che sia chiaro di che file si tratta. Così sarà anche più facile ritrovarlo in un secondo momento.',
        anonymous_sender: {
          button: 'Ottieni un link',
          text: 'Metti qui il tuo indirizzo e-mail così potremo farti sapere quando qualcuno scarica i tuoi file.\n\nTi chiederemo di verificare la tua e-mail per essere sicuri che sei davvero tu. Sei stufo di dover verificare la tua e-mail ogni volta?',
          text_locked_recipient:
            'Metti qui il tuo indirizzo e-mail così potremo farti sapere quando qualcuno scarica i tuoi file. \n \nTi chiederemo di verificare la tua e-mail per essere sicuri che sei davvero tu.',
        },
        prefer_link: {
          button: 'Ottieni un link',
          text: "Non vuoi verificare la tua e-mail? Non c'è problema.",
        },
      },
      button: {
        previews_receiver_learnmore: 'Maggiori info',
        previews_sender_learnmore: 'Maggiori info',
      },
      recipient_locked_text:
        'Questa pagina permette al suo proprietario di ricevere file. Se sei tu questa persona, effettua l\'accesso, oppure vai su <a href="https://wetransfer.com">wetransfer.com</a> per inviare file a qualcun altro.',
      recipient_locked_title: 'Attenzione, attenzione',
      title: {
        previews_receiver: 'Le anteprime immagine',
        previews_sender: 'Le anteprime immagine',
      },
    },
    download: {
      blocked: {
        link: 'Scopri di più',
        text: 'Questo trasferimento ha ricevuto una segnalazione e non può essere scaricato',
        title: 'Trasferimento bloccato',
      },
      title: 'Pronto? Noi ci siamo!',
      expires: 'Il trasferimento scade tra %{relative_time}',
      expires_never: 'Nessuna data di scadenza',
      files: '%{count} file, %{size}',
      format: '%{files}・%{expires}',
      expand: 'di più',
      download_link: 'Scarica link',
      files_nosize: {
        one: '%{count} file',
        other: '%{count} file',
      },
      show_all_files_mobile: 'Mostra tutti i file',
      zip_information:
        'Riceverai un file .zip se scarichi tutti i file contemporaneamente - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">leggi di più</a>',
      files_label: 'Files',
      message: 'Messaggio',
      learn_more: 'scopri di più',
      expires_in: 'Scade tra %{expiry}',
      download_all_zip:
        'Con "Scarica tutto", tutti i file verranno scaricati in formato .zip',
      back_to_transfer: 'Torna al trasferimento',
      cookie_text:
        'Utilizziamo i cookie per offrirti la migliore esperienza possibile. Non temere, non venderemo i tuoi dati a terze parti. Gestisci le tue <a href="https://wetransfer.com/legal/manage-cookies" rel="external">preferenze sui dati</a>.',
    },
    preview: {
      open_grid: 'Anteprima',
      click_to_open: "Fai clic per l'anteprima",
      grid: 'Elementi in questo trasferimento',
      link: 'Sito web',
      not_previewable: 'Non disponibile',
      now_open: 'Anteprima aperta',
      open_link: 'Apri il link in una nuova scheda',
      open_link_short: 'Apri il link',
      overview: 'riepilogo',
      reload: 'Fai clic qui per ricaricare',
      something_went_wrong: 'Mmm, qualcosa è andato storto',
      tap_to_open: 'Anteprima',
      toobig_copy:
        'Possiamo farti vedere in anteprima solo le immagini fino a 50MB - <a href="https://wetransfer.zendesk.com/" rel="external">per maggiori informazioni leggi qui</a>',
      toobig_title:
        'Uff, questa immagine è troppo grande per essere visualizzata in anteprima',
      unsupported_copy:
        'Dai un\'occhiata a <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">questo articolo</a> per scoprire quali file possono essere visualizzati in anteprima',
      unsupported_title: 'Anteprima non disponibile (per ora)',
      visit_website: 'Visita il sito',
    },
    complete_mobile: {
      email_text:
        "L'e-mail del trasferimento è stata inviata – il tuo trasferimento sarà disponibile per %{expires}",
      link_text: 'Copia il link per il download:',
      email_text_no_expiry: "È stata inviata un'e-mail al destinatario.",
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            "<b>Lo sapevi che il 30% del nostro spazio pubblicitario è riservato ad artisti?</b> Accettando i nostri cookie, ci permetti di mostrarti un po' di arte, le cause in cui crediamo e alcune pubblicità pluripremiate per niente invadenti. ",
          text: 'Vuoi accettare anche i cookie di terze parti dei nostri partner pubblicitari per permetterci di personalizzare le pubblicità che vedi? ',
          title: 'I nostri cookie alimentano la cultura',
        },
        subtitle:
          "<b>Ecco perché il 30% del nostro spazio pubblicitario è riservato ad artisti.</b> Accettando i nostri cookie, ci permetti di mostrarti un po' di arte, le cause in cui crediamo e alcune pubblicità pluripremiate per niente invadenti. ",
        text: 'Il nostro sito web utilizza cookie che lo aiutano a funzionare correttamente e ci permettono di capire come usi WeTransfer per migliorarne le prestazioni. Vuoi accettare anche i cookie di terze parti dei nostri partner pubblicitari per permetterci di personalizzare le pubblicità che vedi?',
        title: "Crediamo che l'arte possa smuovere le montagne",
        'title-small': 'Benvenuto in WeTransfer',
      },
      'button-accept': 'Accetto',
      'button-accept-all': 'Accetta tutto',
      'button-ccpa': 'Non accettare la vendita di dati personali',
      'button-cookies-privacy': 'Le tue scelte sulla privacy',
      'button-reject': 'No grazie',
      'button-save': 'Salva',
      'button-save-and-exit': 'Salva e chiudi',
      'ccpa-banner-text':
        'Utilizziamo i cookie per garantirti la migliore esperienza sul nostro sito web. Non temere, non venderemo i tuoi dati a terze parti. Non accetti comunque? <a href="%{href}">Gestisci impostazioni</a>',
      'ccpa-body':
        'Poiché ti trovi negli Stati Uniti, i tuoi diritti sono protetti dal California Consumer Privacy Act (CCPA) e puoi richiederci di interrompere la vendita dei tuoi dati personali. Questo non significa che, in caso contrario, metteremo all\'asta i tuoi dati personali o i file privati al miglior offerente: non lo abbiamo mai fatto, né mai lo faremo! Facciamo tutto il possibile affinché la tua traccia digitale sia ridotta, sicura e sempre sotto il tuo controllo. Puoi ottenere ulteriori informazioni su quali dati raccogliamo e perché nella sezione <a href="%{href}">Le tue scelte sulla privacy</a>.',
      'ccpa-donotsell': 'Non vendere i miei dati personali',
      'ccpa-header': 'Non accettare la vendita di dati personali',
      'ccpa-intro':
        'In qualità di azienda del settore tecnologico impegnata a migliorare internet, non vendiamo i tuoi dati personali a terze parti. Ma tu hai comunque il diritto di non accettare.',
      'ccpa-variant-test-text':
        'Usiamo cookie che ci permettono di garantire un\'esperienza senza interruzioni sul nostro sito web e di personalizzare le pubblicità che vedi. <a href="%{href}">Gestisci i cookie</a>',
      headline: 'Cookie e pubblicità',
      intro:
        'Ciò che guadagniamo dalle nostre bellissime pubblicità ci aiuta a pagare le bollette. È per questo che possiamo permetterci di offrire il nostro servizio di condivisione di file gratuito.',
      'manage-cookies': 'Gestisci i cookie',
      'partners-consent': 'Consenso',
      'partners-features': 'Funzioni',
      'partners-headline': 'I nostri partner',
      'partners-text':
        '<p>Ecco una lista in ordine alfabetico dei partner che abbiamo attentamente selezionato e che sono autorizzati a rilevare i tuoi dati per monitorare e migliorare le nostre prestazioni.</p>',
      'preferences-headline': 'Gestisci i cookie ',
      'preferences-text':
        "<p>Rispettiamo il tuo diritto alla privacy e le tue scelte in relazione ai tuoi dati. Quando utilizzi i nostri strumenti, abbiamo bisogno di gestire alcuni dei tuoi dati personali, ma ci impegniamo ad adottare un approccio responsabile e di principio nel modo in cui svolgiamo la nostra attività, nell'uso della tecnologia e nel rapporto che abbiamo con te.</p> \n<p>Ecco perché facciamo di tutto affinché la tua impronta digitale sia minima, protetta e sotto il tuo controllo.</p> \n<p>Di default, raccogliamo e trattiamo i dati solo quando è strettamente necessario. Ciò nonostante, se desideri sostenere il nostro servizio e fare in modo che WeTransfer rimanga gratuito, permettici di condividere le informazioni con i nostri partner pubblicitari.</p>",
      'preferences-text-allow-cookies':
        "Acconsenti all'uso dei cookie affinché noi e/o i nostri partner possiamo:<br><br>",
      'purpose-description-first-intro':
        "Per promuovere i prodotti sul nostro sito web, sull'app e oltre, WeTransfer può: ",
      'purpose-description-first-list':
        "<ul><li>Raccogliere informazioni su come interagisci con il nostro sito o siti, tra cui il tuo comportamento nella sequenza di clic e le pagine visitate, e se possibile unire queste informazioni ai dati che abbiamo salvato su di te, tra cui il tuo indirizzo e-mail legato all'account</li><li>Usare le informazioni che raccogliamo per presentarti offerte e promozioni via e-mail, sul nostro sito o siti o app, e sui siti web o app di parti terze. Per esempio, potremmo promuovere un altro dei nostri prodotti quando usi WeTransfer Pro.</li></ul>",
      'purpose-description-second-intro':
        "Per promuovere i prodotti sul nostro sito web, sull'app e oltre, i nostri partner possono: ",
      'purpose-description-second-list':
        '<ul><li>Raccogliere informazioni su come interagisci con il nostro sito o siti, tra cui il tuo comportamento nella sequenza di clic e le pagine visitate, e se possibile unire queste informazioni ai dati che hanno salvato su di te</li><li>Usare le informazioni che raccolgono per presentarti offerte e promozioni via e-mail, sul loro sito o siti o app e sui siti web o app delle parti terze con cui collaborano.</li></ul>',
      'purpose-title':
        "Promuovere i prodotti sul nostro sito web, sull'app e oltre.",
      'switch-by-partners': 'Dei partner',
      'switch-by-we-transfer': 'Di WeTransfer',
      text: '<p>Il nostro sito web fa uso di <a href="%{href}">cookie</a> che garantiscono il funzionamento del sito e ci permettono di analizzare come tu interagisci con esso, per aiutarci a migliorarne le prestazioni.</p> \n<p>Acconsenti anche all\'uso dei cookie dei nostri partner pubblicitari per poter personalizzare le pubblicità che vedi e promuovere i prodotti di WeTransfer e dei nostri partner sul nostro sito web, sull\'app e oltre?</p>',
      'text-panel':
        "<p>Il nostro sito web fa uso di cookie che garantiscono il funzionamento del sito e ci permettono di analizzare come tu interagisci con esso, per aiutarci a migliorarne le prestazioni.</p>\n<p>Acconsenti anche all'uso dei cookie dei nostri partner pubblicitari per poter personalizzare le pubblicità che vedi e promuovere i prodotti di WeTransfer e dei nostri partner sul nostro sito web, sull'app e oltre?</p>",
      'tos-experiment': {
        'cookie-intro':
          "Il modo più semplice per inviare file di grandi dimensioni e scoprire fantastiche opere d'arte e pubblicità pluripremiate.",
        'cookie-text':
          'Il nostro sito utilizza cookie che lo aiutano a funzionare e ci permettono di analizzare come tu interagisci con esso, per migliorarne le prestazioni. \nAccettando i nostri cookie, ci permetti di mostrarti pubblicità personalizzate. Si è capito che stiamo parlando di cookie? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'La nostra missione è rendere il mondo più bello attraverso pubblicità pluripremiate, non invadenti, e contribuire al ripristino delle foreste marine.',
          title: 'I nostri cookie proteggono il pianeta',
        },
        subtitle:
          "Accettando i nostri cookie, ci aiuti ad ampliare il nostro raggio di azione a favore del pianeta. Solo quest'anno, WeTransfer si è impegnato a piantare oltre 175.000 alberi. Ed è solo l'inizio. Avrai un impatto positivo anche semplicemente guardando le nostre pubblicità pluripremiate. ",
        text: 'Il nostro sito web utilizza cookie per migliorare le prestazioni e il servizio, e per comprendere meglio ciò di cui hai bisogno. Accettando i nostri cookie di terze parti, noi e i nostri partner potremo offrirti pubblicità più rilevanti sui nostri siti web, app e oltre.',
        title: 'Trasferisci idee. <b>Trasforma il mondo.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Sblocca Collect Pro',
      title: 'Salva e condividi la tua ispirazione on the go',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Dimmi di più',
      title: 'Paste® Pro e Collect Pro sono ora inclusi nella tua iscrizione',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Sblocca Paste® Pro',
      title: 'Trasforma le tue grandi idee in bellissime presentazioni',
    },
    terms_conditions: {
      experiment: {
        text: 'Per continuare, accetta i nostri <a href="/legal/terms" data-route-type="plus">Termini di servizio</a>.',
        title: "Ci sei <span class='tc-title-exp'>quasi</span>",
        ustitle:
          "Benvenuto nel modo più semplice per <span class='tc-title-exp'>inviare file di grandi dimensioni.</span>",
      },
      title: 'Per prima cosa...',
      text: 'Per proseguire, accetta i nostri <a href="/legal/terms" data-route-type="plus">Termini di servizio</a> e la <a href="/legal/privacy" data-route-type="plus">Politica sui cookie</a>. Usiamo i cookie per scopi funzionali e analitici, e i cookie di terze parti a scopi pubblicitari.',
      language: 'La lingua è impostata su',
      button: 'Accetto',
    },
    upsell_pricing: {
      text: 'Confronta i piani',
      title: 'Vuoi inviare trasferimenti più grandi?',
      receiving: {
        title: 'Vuoi ottenere il massimo da WeTransfer?',
      },
    },
    welcome: {
      card1:
        "Invia e ricevi trasferimenti da %{transfer_limit} con un'unica <strong>panoramica condivisa</strong>",
      card2:
        'Consegna i tuoi lavori dalla <strong>pagina WeTransfer personalizzata</strong> del tuo team',
      card3:
        'Lavora a più mani su slide in <strong>Paste®</strong> e board in <strong>Collect</strong>',
      cta: 'Iniziamo',
      headline: 'Sei entrato nel team, <strong>%{first_name}!</strong>',
      'opt-in':
        'Voglio ricevere storie di grande creatività e le ultime novità di WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} file · %{remaining} rimanenti',
        other: '%{count} file · %{remaining} rimanenti',
      },
      add_files: 'Carica i file',
      more_files: 'Aggiungi altri file',
      available_space: 'Aggiungi fino a %{size}',
      message: 'Messaggio',
      from: 'La tua e-mail',
      to: "Invia un'e-mail a",
      other_recipients: {
        one: '+%{count} altro',
        other: '+%{count} altri',
      },
      reset_forward: 'Annulla questo inoltro',
      drop_files: 'o trascina e rilascia',
      files_count: {
        one: '%{count} file aggiunto · %{fileSize} in totale',
        other: '%{count} file aggiunti · %{fileSize} in totale',
      },
      select_folder: 'O seleziona una cartella',
    },
    progress: {
      title: 'Trasferimento in corso...',
      title_finalizing_one: 'Finalizing...',
      title_finalizing_two: 'Almost there...',
      title_finalizing_three: 'One more moment...',
      title_finalizing_four: 'Wrapping up...',
      subtitle_finalizing:
        'Do not close this window until we complete the transfer',
      title_cancel: 'Annullare questo trasferimento?',
      uploaded: '%{sent} di %{total} caricato',
      remaining: {
        minutes: {
          zero: 'Meno di 1 minuto rimanente',
          one: 'Circa 1 minuto rimanente',
          other: 'Circa %{count} minuti rimanenti',
        },
        hours: {
          one: 'Circa 1 ora rimanente',
          other: 'Circa %{count} ore rimanenti',
        },
      },
      document_title: '%{percentage}% - Trasferimento in corso...',
      meta: {
        email: {
          one_file_one_recipient:
            'Invio di %{filesCount} file a %{recipientsCount} persona',
          one_file_other_recipients:
            'Invio di %{filesCount} file a %{recipientsCount} persone',
          other_files_one_recipient:
            'Invio di %{filesCount} file a %{recipientsCount} persona',
          other_files_other_recipients:
            'Invio di %{filesCount} file a %{recipientsCount} persone',
        },
        link: {
          one: 'Invio di %{count} file',
          other: 'Invio di %{count} file',
        },
      },
    },
    complete_link: {
      title: 'Hai finito!',
      text: 'Copia il link per il download o <a href="/transfer/progress">guarda cosa c\'è dentro</a>',
      text_copied: 'Il link è stato copiato negli appunti',
      text_manual_copy:
        'Il tuo link è pronto \nPremi %{shortcut} per copiarlo negli appunti',
      document_title: 'Fatto!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Il tuo trasferimento è stato inoltrato',
    },
    complete_email: {
      title: 'Hai finito!',
      text: 'L\'e-mail del trasferimento è stata inviata – il tuo trasferimento sarà disponibile per %{expires}. <a href="/transfer/progress">Guarda cosa c\'è dentro</a>',
      text_no_expiry:
        'L\'e-mail del trasferimento è stata inviata. <a href="/transfer/progress">Guarda cosa c\'è dentro</a>',
      document_title: 'Inviato!',
      text_no_details:
        "L'e-mail del trasferimento è stata inviata – il tuo trasferimento sarà disponibile per %{expires}.",
      team_discovery_title: 'Trasferimento inviato!',
      team_discovery_text:
        'Il tuo trasferimento sarà disponibile per il download per %{expires}',
    },
    failed: {
      title: 'Qualcosa è andato storto',
      text: 'Sembra che il tuo trasferimento non abbia funzionato; riprova',
    },
    pending: {
      title: 'Ci stiamo lavorando',
      subtitle: 'Preparazione in corso...',
    },
    downloading: {
      title: 'Trasferimento file in corso...',
      text: 'Stiamo preparando il tuo download',
    },
    downloaded: {
      title: 'Download iniziato',
      text: 'Finito il download, i file saranno sul tuo computer (di solito nella cartella "Download")',
      download_links:
        'Sappi che i link in questa Board non appariranno. <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">Per saperne di più leggi qui</a>.',
    },
    expired: {
      title: 'Trasferimento scaduto',
      text: 'Purtroppo questo trasferimento è scaduto e non è più disponibile',
    },
    password: {
      title: 'Inserisci password',
      text: 'Hai bisogno di una password per scaricare questo trasferimento',
    },
    options: {
      transfer_type: 'Invia come',
      password: 'Password',
      password_placeholder: 'Imposta password',
      expiry: 'Scade dopo',
      expire_in: {
        '1w': '1 settimana',
        '2w': '2 settimane',
        '1m': '4 settimane',
        never: 'Mai',
        '14d': '2 settimane',
        '28d': '4 settimane',
        '365d': '1 anno',
        '7d': '1 settimana',
        '90d': '3 mesi',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: "Invia l'e-mail per il trasferimento",
      transfer_link: 'Ottieni il link per il trasferimento',
    },
    buttons: {
      transfer: 'Trasferisci',
      forward: 'Inoltra',
      new_transfer: 'Invia un file?',
      cancel: 'Annulla',
      cancel_no: 'No',
      cancel_yes: 'Sì',
      copy_link: 'Copia il link',
      ok: 'Okay',
      done: 'Invia un altro?',
      team_discovery_done: 'Invia nuovo trasferimento',
      retry: 'Riprova',
      continue: 'Continua',
      download: 'Scarica',
      download_all: 'Scarica tutto',
      back_to_home: "Torna all'home page",
      cleanup: 'Revisione trasferimenti ',
      download_all_files: 'Scarica tutti i file',
      help: 'Centro assistenza',
      payment: 'Rinnova adesso',
      complete_order: 'Vai al checkout',
      download_all_experiment: 'Scarica tutto in un file .zip',
      download_experiment: 'Scarica file',
      download_file: 'Scarica il file',
      download_zip: 'Scarica tutto in un file .zip',
      get_link: 'Ottieni il link',
      go_to_transfer: 'Vai al trasferimento',
      openinapp: "Salva con l'app di WeTransfer",
      openinapp_experiment: "Salva con l'app di WeTransfer",
      openincollectapp: 'Salva con la Collect App',
      get_a_link: 'Ottieni un link',
    },
    account_expired: {
      text: 'Rinnovalo subito per continuare a usufruire di tutti i vantaggi dell\'account Pro oppure <a href="#signout">fai il log out</a> per usare il nostro servizio gratuito',
      title: 'Il tuo account Pro è scaduto',
    },
    invalid: {
      text: 'Non è stato possibile trovare i tuoi file',
      title: 'Oh-oh…',
      link: 'Scopri di più',
    },
    outdated_browser: {
      text: 'WeTransfer supporta molti browser web, ma sembra che tu stia utilizzando una versione vecchia — aggiorna il tuo browser',
      title: 'Il tuo browser web non è aggiornato',
    },
    spam: {
      text: 'Questo trasferimento è stato segnalato come spam ed è stato eliminato',
      title: 'Mmm...',
    },
    upsell: {
      text: 'Aumenta il limite',
      limit: 'Fino a %{limit} gratis',
      remaining: '%{remaining} rimanenti',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passa a WeTransfer Pro',
      title: 'Trasferimenti protetti da password per maggiore tranquillità',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passa a WeTransfer Pro',
      title: 'Un modo semplice e intelligente di gestire i trasferimenti',
    },
    upsell_one: {
      bubble: {
        button: 'Ottieni Pro',
        text: 'Potrai aggiungere una password per proteggere i tuoi trasferimenti e impostare una data di scadenza a tua scelta.',
        title: 'Vuoi migliorare i tuoi trasferimenti?',
        text_experiment:
          'Con Pro puoi stabilire password e date di scadenza dei tuoi trasferimenti.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer su Facebook',
      title: 'Entra nella community WeTransfer su Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passa a WeTransfer Pro',
      title: 'Personalizza il tuo profilo WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Passa a WeTransfer Pro',
      title: 'Più grande, migliore, più forte, più veloce',
    },
    account_inactive: {
      text: 'Completa la tua registrazione per iniziare a usare Pro',
      title: 'Il tuo account non è ancora attivo',
      tiers: {
        text: 'Completa il tuo pagamento per iniziare a usare %{plan}.',
        title: 'La tua iscrizione non è ancora attiva',
      },
    },
    add_items: {
      files: 'File',
      folders: 'Cartelle',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Vuoi vedere cosa c\'è dentro</a>?',
    },
    details: {
      button: {
        dismiss: 'Ignora',
      },
    },
    download_preview: 'Scarica il file',
    error: {
      expired: {
        link: 'Contatta il nostro team di assistenza.',
        text: 'Cavolo, sembra che il tuo trasferimento non sia già più disponibile.\nNon ti tornano i conti?',
        title: 'Trasferimento non più disponibile',
      },
    },
    item: {
      details: {
        folder: 'Cartella',
      },
    },
    items: {
      zero: 'vuoto',
      one: '%{count} elemento',
      other: '%{count} elementi',
    },
    mobile: {
      button: {
        back: 'Indietro',
        cancel: 'Ricomincia',
        next: 'Avanti',
      },
      email: {
        title: 'Aggiungi gli indirizzi e-mail',
      },
      message: {
        placeholder: 'Aggiungi un messaggio al tuo trasferimento',
        title: 'Messaggio',
      },
      options: {
        email: 'Invia una e-mail',
        'email-description':
          'Invia il tuo trasferimento con una semplice e-mail e ti faremo sapere quando il destinatario avrà effettuato il download.',
        link: 'Ottieni un link',
        'link-description':
          'Trasforma i tuoi file in un link e condividilo come più ti piace.',
      },
    },
    recaptcha: {
      button: 'Sono umano al 100%',
      text: 'Ora dobbiamo solo verificare che tu non sia un robot (senza offesa)',
      title: 'Ci siamo quasi!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Dacci una mano',
      title:
        'Possiamo chiederti qualche informazione sul tuo modo di lavorare?',
    },
    'verification-code': 'Codice di verifica',
    verify: {
      button: 'Trasferisci',
      text: 'Nella tua casella di posta si trova il codice di verifica, inseriscilo qui sotto.',
      title: "C'è posta per te",
      'verification-code': 'Codice di verifica',
    },
    'account-verification-failed': {
      body: 'Stiamo avendo qualche problema nel confermare la tua e-mail. Invia un nuovo link per fare un altro tentativo.',
      cta: 'Vuoi ricevere un nuovo link?',
      title: 'Qualcosa è andato storto',
    },
    'cookie-banner': {
      'button-accept': 'Ok',
      'button-decline': 'Naa',
      text: 'Facciamo uso di <a href="%{href}">cookie</a> che ci permettono di far funzionare il sito correttamente, di analizzare come i nostri utenti interagiscono e di migliorarlo. Autorizzi anche l\'uso di cookie di terze parti per ricevere pubblicità personalizzate?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Usiamo i cookie analitici per capire come utilizzi WeTransfer. I cookie ci permettono di eseguire test A/B sulle nuove funzionalità, garantendo che tutto funzioni come previsto e bloccando bot e comportamenti fraudolenti, come lo spam. Questi cookie potrebbero comprendere cookie di terze parti che elaborano dati personali. ',
        title: 'Cookie analitici',
      },
      clear: {
        'clear-all-cookies': 'Elimina tutti i cookie',
        description:
          'È possibile rimuovere tutti i tuoi dati dai nostri cookie. Per richieste di anonimato definitivo, contatta <a href="mailto:support@wetransfer.com">il nostro team di assistenza.</a>',
        title: 'Elimina i cookie',
        warning:
          'Dopo avere cancellato tutti i cookie verrai disconnesso da WeTransfer. Questa scelta non pregiudicherà i trasferimenti sul tuo account.',
      },
      functional: {
        description:
          "Utilizziamo cookie funzionali per offrirti un'esperienza ottimale su WeTransfer. Questi cookie sono necessari per utilizzare il nostro servizio.",
        title: 'Cookie funzionali',
      },
      'not-yet-set':
        'Sembra che tu non abbia ancora espresso le tue preferenze sui cookie. Chiudi questo pannello e imposta le tue preferenze: potrai sempre modificarle in un secondo momento.',
      'save-and-reload': 'Salva impostazioni',
      tracking: {
        description:
          'Utilizziamo cookie pubblicitari sul nostro servizio per poter valutare il successo dei nostri sforzi commerciali, editoriali e promozionali. I cookie pubblicitari non vengono inseriti su pagine che forniscono informazioni sul nostro brand e sui nostri prodotti. I cookie pubblicitari ci consentono, ad esempio, di rilevare che hai cliccato su una specifica pubblicità. Se i cookie inseriti da terze parti sono collocati anche su altri domini o siti web, gli inserzionisti potrebbero essere in grado di seguire i tuoi comportamenti su internet, ma WeTransfer non potrà accedere o utilizzare nessuno dei dati personali eventualmente raccolti. Di conseguenza, ti invitiamo a consultare le informative sulla privacy delle terze parti in questione.',
        title: 'Cookie pubblicitari',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Mmm, qualcosa è andato storto',
        'error-email-exists': 'Mmm, pare che questa e-mail sia già in uso',
        'throttle-error':
          'Frena, tigre! Ti abbiamo già inviato fin troppe e-mail. Aspetta %{throttle_time} prima di richiedere un nuovo codice.',
      },
      back: 'Torna al codice di verifica',
      body: "Abbiamo capito bene? Questa è l'e-mail che stai usando su WeTransfer.",
      email: 'E-mail',
      error: 'Mmm, qualcosa è andato storto',
      'error-email-exists': 'Mmm, pare che questa e-mail sia già in uso',
      submit: 'Invia di nuovo',
      'throttle-error':
        'Purtroppo hai già fatto troppi tentativi. Avvia di nuovo il tuo trasferimento.',
      'throttle-error-action': 'Avvia di nuovo',
      'throttle-error-link':
        'Frena, tigre! Ti abbiamo già inviato fin troppe e-mail. Aspetta %{throttle_time} prima di richiedere un nuovo e-mail.',
      title: 'Controlla la tua e-mail',
    },
    'email-verification-success': {
      body: 'Ora tutti sapranno che sei davvero tu a inviare i trasferimenti.',
      free_signup: 'Crea un account gratuito',
      onboarding_body:
        'Batti cinque, sei dei nostri! Pronto a scegliere il tuo URL e i tuoi sfondi personali?',
      onboarding_title: 'Benvenuto in<br/>WeTransfer Pro!',
      send_files: 'Invia file',
      start_onboarding: "Let's go",
      title: 'Il tuo account è stato verificato!',
      upsell: 'Non vuoi verificare la tua e-mail ogni volta?',
      verified_sender_tooltip:
        'Il tuo indirizzo e-mail è stato verificato: ora tutti sapranno che sei stato proprio tu a inviare i trasferimenti. Per modificare l\'indirizzo e-mail, aggiorna i tuoi <a href="%{href}">dettagli personali</a>.',
      verified_sender_tooltip_icon:
        'Il tuo indirizzo e-mail è stato verificato. Ora tutti sapranno che sei stato proprio tu a inviare i trasferimenti.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          "Oh oh, quel codice è sbagliato o scaduto. Tutti i codici restano attivi solo per %{expiry_time} dopo l'invio.",
        'error-expiry-time-action': 'Ottieni un nuovo codice',
        'throttle-error':
          'Hai inserito troppe volte un codice sbagliato o scaduto. Aspetta %{throttle_time} prima di richiedere un nuovo codice.',
      },
      back: 'No, torna indietro',
      body: 'Abbiamo inviato un codice di verifica all\'indirizzo <strong title="%{account_email}">%{account_email}</strong> per accertarci che tu sia veramente tu. (Ricordati di controllare la cartella Spam).',
      body_link:
        'Vogliamo solo essere sicuri che sei davvero tu.<br/><br/>Ti abbiamo inviato un link di verifica all\'indirizzo <strong title="%{account_email}">%{account_email}</strong> (se non lo trovi, controlla nello spam).',
      error: 'Oh oh, quel codice è sbagliato o scaduto',
      'error-expiry-time':
        "Oh oh, quel codice è sbagliato o scaduto. Tutti i codici restano attivi solo per %{expiry_time} dopo l'invio.",
      'error-expiry-time-action': 'Ottieni un nuovo codice',
      resend: 'Non hai ricevuto nessuna e-mail?',
      submit: 'Verifica',
      'throttle-error':
        'Purtroppo hai già fatto troppi tentativi. Avvia di nuovo il tuo trasferimento.',
      'throttle-error-action': 'Avvia di nuovo',
      title: 'Conferma la tua e-mail',
      'verification-code': 'Inserisci il codice di verifica',
    },
    'force-account-verification': {
      body: "Ti invieremo un link per confermare l'indirizzo e-mail che stai usando in WeTransfer.",
      cta: 'Invia e-mail',
    },
    'marketing-email-prompt': {
      body: "Solo un'ultima cosa: desideri ricevere le novità di WeTransfer e gli aggiornamenti sui prodotti?",
      skip: 'No, grazie',
      subscribe: 'Sì, stiamo in contatto',
      title: 'Verifica completata!',
    },
    'terms_conditions-no-cookies': {
      text: 'Per continuare, accetta i nostri <a href="/legal/terms?from_home" data-route-type="plus">Termini di servizio</a>.',
    },
    mobile_web: {
      ios_banner_prompt: "Ricevi i tuoi file nell'app WeTransfer",
      ios_banner_prompt_send: 'Invia file in modo facile e veloce',
      tnc_subtitle:
        'Il modo più semplice per inviare file di grandi dimensioni',
    },
  },
  account: {
    legend: {
      plan: 'Piano',
      save: 'risparmia il %{amount}%',
      subscription: 'Iscrizione',
      summary: "Riassunto dell'ordine",
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info':
      'Ecco perché ti stiamo chiedendo di confermare la tua e-mail',
    workspace: {
      default_workspace: 'Spazio di lavoro di %{name}',
      your_workspace: 'Il tuo spazio di lavoro',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Le tue scelte sulla privacy',
        subtitle: 'Gestisci i tuoi dati',
        p1: 'Desideriamo fornirti sempre la migliore esperienza possibile, anche quando si tratta delle nostre pubblicità.',
        p2: 'Vorremmo utilizzare i dati che scegli di condividere, come il tuo indirizzo e-mail, per capire quali tipi di contenuti sono più adatti a te e utilizzarli per mostrarti (e mostrare ad altre persone simili a te) gli annunci di WeTransfer più adatti alle tue esigenze.',
        p3: 'Tutto ciò che crei e condividi con WeTransfer rimarrà accessibile solo a te: non lo leggeremo né lo utilizzeremo mai per scopi pubblicitari.',
        p4: 'Se deciderai di condividere questi dati con noi, li terremo sempre al sicuro.',
        control_label:
          'Consenti a WeTransfer di utilizzare i dati che condividi, come indirizzo e-mail e settore lavorativo, per personalizzare gli annunci che visualizzerai sul nostro sito e su altri siti web.',
      },
      vertical_nav: {
        terms_of_service: 'Termini di servizio',
        privacy_and_cookie_statement:
          'Dichiarazione sulla privacy e sui cookie',
        your_privacy_choices: 'Le tue scelte sulla privacy',
        notice_and_takedown_policy: 'Informativa su notifiche e rimozioni',
        responsible_disclosure_policy:
          'Informativa sulla divulgazione responsabile',
        advertising_terms_and_conditions:
          'Condizioni e termini della pubblicità',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Chiudi che voglio iniziare a trasferire i miei file',
  },
  account_start_screen: {
    'collect-description':
      'Salva tutte le tue fonti di ispirazione in un unico luogo, sia dal telefono che da laptop o tablet.',
    'collect-title': 'Vai su Collect',
    'paste-description':
      'Crea bellissime slide nel giro di pochi secondi con slide di presentazione che si progettano da sole.',
    'paste-title': 'Vai su Paste®',
    title: 'Tre strumenti. Un account. Infinite possibilità.',
    'transfer-cta': 'Prontissimo',
    'transfer-description':
      'Fai sempre una buona impressione ogni volta che qualcuno scarica i tuoi file. Sei pronto a scegliere il tuo URL personalizzato e gli sfondi?',
    'transfer-title': 'Configura la tua pagina WeTransfer personalizzata',
  },
  account_welcome_screen: {
    'pro-title': 'Benvenuto su WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Sì, ci sto',
    'accept-short': 'Ok',
    body_1:
      'Vuoi ricevere storie di grande creatività e le ultime novità di WeTransfer?',
    body_2: '(Puoi sempre disiscriverti in un secondo momento).',
    decline: 'No, grazie',
    'decline-short': 'No, grazie',
    title: 'Benvenuto in WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Accetta i cookie',
      deny: 'Rifiuta i cookie',
      manage: 'Gestisci i cookie',
    },
    description:
      "Utilizziamo cookie regolari e analitici per garantire un'esperienza ottimale e cookie di terze parti per scopi pubblicitari.",
    heading:
      'Scopri il modo più semplice per inviare file di grandi dimensioni',
    snippet: 'Ti diamo il benvenuto su WeTransfer',
  },
  dropzone: {
    pro: {
      title: '<span>Molla</span> qui<br>la patata bollente',
    },
    title: "Drop it like it's hot",
    text: 'Carica i tuoi file o le tue cartelle trascinandoli ovunque in questa finestra',
  },
  form: {
    account: {
      billing_address: 'Indirizzo di fatturazione',
      billing_cta: 'Vai al pagamento',
      billing_title: 'Dati di fatturazione',
      legend: {
        details: 'I tuoi dati per la fatturazione',
        coupon_code: 'Aggiungi un codice sconto',
        free_plus: 'Ottieni il tuo account Pro gratis',
      },
      label: {
        year_label: 'Per anno',
        year_sublabel: "L'offerta migliore: risparmia %{discount_rate}%!",
        month_label: 'Per mese',
        month_sublabel: 'Fatturazione periodica',
        email: 'Indirizzo e-mail',
        not_required: '(opzionale)',
        current_password: 'Password attuale',
        new_password: 'Nuova password',
        repeat_new_password: 'Conferma nuova password',
        password: 'Password',
        password_confirm: 'Conferma password',
        full_name: 'Nome completo',
        company: 'Azienda',
        street_and_number: 'Indirizzo',
        city: 'Città',
        zipcode: 'CAP',
        country_code: 'Nazione',
        vat_number: 'IVA',
        coupon_code: 'Codice sconto',
        family_name: 'Cognome',
        given_name: 'Nome',
        state_code: 'Stato',
      },
      description: {
        password: 'Seleziona una password composta da almeno 6 caratteri',
        vat_number:
          "Le società con sede in Olanda sono soggette all'IVA con aliquota del 21%. Se la tua azienda ha sede fuori dall'Olanda, ma all'interno dell'UE, inserisci i dati dell'azienda e il codice identificativo fiscale europeo per eliminare l'IVA dalla fattura. \n\nSe la tua azienda ha sede fuori dall'UE, abbiamo bisogno ugualmente dei tuoi dati per la fatturazione, ma non applicheremo l'IVA.",
      },
      error: {
        email: {
          blank: 'Inserisci il tuo indirizzo e-mail',
          invalid: 'Inserisci un indirizzo e-mail valido',
          taken: 'Questo indirizzo e-mail è già in uso',
          taken_login:
            'Sembra che tu abbia già un account. <a class="form-notification__message-link" href="%{login_url}">Vuoi accedere?</a>',
        },
        current_password: {
          invalid: 'Password non riconosciuta',
          blank: 'Inserisci la tua password attuale',
        },
        password: {
          blank: 'Inserisci la tua nuova password',
          too_short: 'La password deve contenere almeno 6 caratteri',
        },
        password_confirm: {
          blank: 'Conferma la tua nuova password',
          confirm: 'Queste password non corrispondono',
        },
        full_name: {
          blank: 'Inserisci il tuo nome completo',
          too_short: 'Ops, il tuo nome deve contenere un minimo di 3 caratteri',
        },
        street_and_number: {
          blank: 'Inserisci il tuo indirizzo',
        },
        city: {
          blank: 'Inserisci la tua città',
        },
        zipcode: {
          blank: 'Inserisci il tuo CAP',
        },
        country_code: {
          inclusion: 'Controlla lo spelling o prova con una nazione diversa',
          blank: 'Inserisci la tua nazione',
        },
        vat_number: {
          vat_number: 'Inserisci un numero di partita IVA valido',
        },
        terms_of_service: {
          accepted: 'Accetta i Termini del servizio per proseguire',
        },
        no_results: 'Controlla lo spelling o prova con una nazione diversa',
        convert: {
          expired:
            'Purtroppo questo trasferimento è già scaduto e non può essere salvato. Sapevi che WeTransfer Pro ti permette di conservare i trasferimenti per tutto il tempo che vuoi? Per saperne di più, fai clic qui.',
        },
        coupon_code: {
          coupon_code: 'Inserisci un codice sconto valido',
        },
        no_state_results: 'È uno stato?',
      },
      complete_order: 'Completa il tuo ordine',
      terms_conditions:
        'Accetto i <a href="/legal/terms" %{options}>Termini del servizio</a> e ho letto I\'<a href="/legal/privacy" %{options}>Informativa sulla privacy e sui cookie</a>',
      signup_for_plus: 'Effettua la registrazione su WeTransfer Pro',
      account_cta: 'Cominciamo',
      signup_for_account: 'Registrati per ottenere un account WeTransfer',
      'email-verification-not-verified-link':
        'Verifica il tuo indirizzo e-mail. Controlla l\'e-mail che ti abbiamo inviato o <button type="button" class="button button--link">richiedine un\'altra</button>.',
      'email-verification-resend': {
        error: 'Mmm, qualcosa è andato storto',
        info: 'Nuovo codice inviato! Controlla la tua casella di posta',
        info_link: 'Nuova e-mail inviata! Controlla la tua casella di posta',
        'throttle-error':
          'Frena, tigre! Ti abbiamo già inviato fin troppe e-mail. Aspetta %{throttle_time} prima di richiedere un nuovo codice.',
      },
      'force-account-verification': {
        message:
          'Verifica il tuo indirizzo e-mail per farci sapere che sei davvero tu.',
      },
      marketing_opt_in:
        'Voglio ricevere le novità e gli aggiornamenti sui prodotti WeTransfer',
      sso: {
        header: 'Dettagli personali',
        password_reset: {
          button: 'Invia e-mail',
          instructions:
            "È il momento di cambiare (password)? Ci pensiamo noi. Clicca sul pulsante qui sotto e ti invieremo un'e-mail all'indirizzo <span>%{email}</span> con un link per cambiare la tua password.",
          success: 'E-mail inviata! Controlla la tua posta in arrivo.',
          title: 'Modifica la password',
        },
        wrong_user: 'Non sei tu? Esci',
      },
    },
    payment_cancel: {
      submit: 'Conferma',
      client_request:
        'Ho utilizzato WeTransfer su richiesta di un cliente ma ora non ne ho più bisogno',
      different_tool: 'Ho scoperto un nuovo strumento',
      extra_features:
        'Ho bisogno di funzioni aggiuntive che qui non sono incluse',
      not_enough_storage: "Non c'è abbastanza spazio per me",
      not_often_large_files:
        'Non mi capita abbastanza spesso di inviare file di grandi dimensioni',
      other: 'Altro',
      other_more: 'Puoi dirci di più?',
      skip: 'Salta e cancella la sottoscrizione',
      temp_project:
        'Avevo bisogno di inviare file di grandi dimensioni solo per un progetto a termine',
      too_expensive: "Mi sembra un po' troppo costoso",
    },
    payment_cancel_reason: {
      skip: 'Non desidero lasciare feedback',
    },
    profile: {
      label: {
        profile_title: 'Nome profilo',
        wallpaper_link: 'Sito Web per collegare sfondi a...',
      },
      error: {
        subdomain_name: {
          too_short:
            'Conosciamo il motto "meno è meglio", ma il tuo URL WeTransfer deve contenere almeno 2 caratteri',
          domain_name: 'Purtroppo qualcuno ha già usato questo nome',
          invalid:
            'Frena, tigre! Il tuo URL WeTransfer può contenere solo lettere e numeri (o al massimo un trattino nel mezzo)',
          taken: 'Purtroppo qualcuno ha già usato questo nome',
        },
        subdomain: {
          too_short: 'Continua con almeno altri 2 caratteri',
          too_long: 'Ehi, ricorda: meno di 63 caratteri',
          invalid:
            'Frena, tigre! Il tuo URL WeTransfer può contenere solo lettere e numeri (o al massimo un trattino nel mezzo)',
          domain_name: 'Questo URL è già in uso',
          taken: 'Questo URL è già in uso',
        },
        default_recipient_email: {
          invalid: 'Inserisci un indirizzo e-mail valido',
        },
        wallpaper_link: {
          invalid: 'Inserisci un indirizzo Web valido',
        },
      },
      success: {
        subdomain: {
          updated: 'Il tuo URL è stato aggiornato',
          available: 'Buone notizie, questo URL è disponibile',
        },
      },
      change_background: 'Carica sfondo',
      delete_avatar: 'Cancella avatar',
      delete_background: 'Cancella sfondo',
      description: {
        title:
          'Psst, non superare i 150 caratteri altrimenti rischi che qualcosa resti fuori dalla pagina',
        wallpaper_link:
          'I tuoi sfondi saranno collegati a questo indirizzo Web',
        recipient_email_locked:
          'Files sent through your profile will only go to this e-mail address',
      },
      upload_avatar: 'Carica avatar',
      use_email_background_checkbox_label:
        'Usa questo sfondo per tutti i trasferimenti inviati tramite il mio profilo',
      account_email_checkbox: "Mostra l'indirizzo e-mail nel profilo",
      default_recipient_email_info:
        'Puoi cambiare questo indirizzo e-mail nei tuoi <a href="/account">dettagli personali</a>',
      change_subdomain: {
        message:
          'Modificare l\'URL in <a href="%{url}">%{subdomain}wetransfer.com</a>? Quello precedente diventerà subito disponibile.',
        confirm: 'Sì, modifica URL',
        cancel: 'Torna indietro',
      },
    },
    fill_in_password: 'Inserisci la tua password per salvare queste modifiche',
    select_all: 'Seleziona tutto',
    deselect_all: 'Deseleziona tutto',
    save_changes: 'Salva modifiche',
    save: 'Salva',
    submitting: 'Invio in corso...',
    cancel: 'Annulla',
    forward: 'Inoltra',
    proceed: 'Continua',
    delete: 'Elimina',
    onboarding: {
      placeholder: {
        subdomain_name: 'scegli-un-nome-che-sia-bello',
      },
      validated: {
        subdomain_name: 'Buone notizie: questo dominio è disponibile',
      },
    },
    confirm_leave:
      'Abbandonare questa pagina? Perderai tutte le modifiche non salvate',
    unsaved_changes:
      'Abbandonare la pagina? Le modifiche non salvate andranno perse.',
    contact: {
      add_contact: 'Aggiungi contatto',
      error: {
        email: {
          duplicate:
            'Questo indirizzo e-mail è già nel tuo elenco dei contatti',
          invalid: 'Inserisci un indirizzo e-mail valido',
        },
      },
      label: {
        company: 'Azienda',
        email: 'Indirizzo e-mail',
        name: 'Nome',
      },
    },
    error: {
      current_password: {
        blank: 'Inserisci la password corrente',
        invalid: 'Password non riconosciuta',
      },
      email: {
        blank: 'Inserisci il tuo indirizzo e-mail',
        duplicate: 'Questo indirizzo e-mail è già nel tuo elenco dei contatti',
        invalid: 'Inserisci un indirizzo e-mail valido',
        taken: 'Questo indirizzo e-mail è già in uso',
      },
    },
    leave: 'Esci',
    resetpassword: {
      button: {
        request_submit: 'Invia',
        reset_submit: 'Salva la nuova password',
      },
      label: {
        confirm_new_password: 'Conferma nuova password',
        email: 'Indirizzo e-mail',
        new_password: 'Nuova password',
      },
      legend: {
        request_description:
          'Non riesci ad accedere? Ti invieremo le istruzioni per ripristinare la password e rientrare.',
        request_title: 'Hai dimenticato la password?',
        reset_description: 'Inserisci una nuova password per rientrare',
        reset_title: 'Imposta una nuova password',
        request_description_success_or_article:
          'Se hai un account WeTransfer, ti abbiamo inviato le istruzioni per resettare la tua password. Dai un\'occhiata a questo <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">articolo del centro assistenza</a> se non ricevi un\'e-mail nel giro di pochi minuti.',
      },
    },
    signin: {
      button: {
        submit: 'Login',
      },
      label: {
        email: 'Indirizzo e-mail',
        password: 'Password',
        remember_me: 'Ricordami',
      },
      link: {
        forgot_password: 'Password dimenticata?',
      },
      title: 'Accedi',
    },
    stay_on_page: 'Rimani nella pagina',
    close_panel: 'Chiudi',
    go_back: 'No, torna indietro',
    labels: {
      email: 'Indirizzo e-mail',
    },
    plan: {
      change: {
        month: 'Mensile (%{currency}%{price})',
        title: 'Cambia il tuo piano',
        year: 'Annuale (%{currency}%{price})',
      },
      change_plan: 'Modifica il piano di pagamento',
      month: {
        copy: 'Fatturazione periodica',
        label: 'Mensile',
        'label-payment': 'Pagamento mensile',
        'sub-label': 'Una fattura al mese',
        title: 'WeTransfer Pro: pagamento mensile',
      },
      title: 'Riserva alle tue idee il trattamento premium che meritano',
      year: {
        discount: 'Risparmia il %{rate}% (ooh yeah)',
        'label-payment': 'Pagamento annuale',
        'sub-label': 'Ben il 17% di risparmio. Tac',
        title: 'WeTransfer Pro: pagamento annuale',
      },
      your_order: 'Il tuo ordine',
    },
    save_and_continue: 'Salva e continua',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Inserisci la tua password per continuare',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Non ora',
        true: "Apri nell'app WeTransfer",
      },
      headline: 'Perché non pensare più in grande?',
      headline2: "Vuoi visualizzare i file nell'app?",
      subheader: 'Invia e ricevi 200 GB con WeTransfer Pro',
      subheader2:
        'Visualizza i file prima di scaricarli. Invia e ricevi trasferimenti, traccia i download e ricevi notifiche.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Rinnova subito per continuare a usufruire di tutti i vantaggi del tuo account %{tier}',
      account_expired_title_tier: 'Il tuo account %{tier} è scaduto',
      account_inactive_title_tier: 'Pronto per passare a %{tier}',
      account_inactive_action: 'Sì, continua',
      account_inactive_subtitle:
        "Ancora un'ultima cosa e abbiamo finito. Hai cambiato idea? Nessun problema—",
      account_inactive_title: 'Pronto per passare a Pro?',
      account_subscription_action: 'Rinnova adesso',
      account_subscription_expired: 'Il tuo account Pro è scaduto',
      account_subscription_subtitle:
        'Rinnovalo subito per mantenere i tuoi trasferimenti, i tuoi sfondi personali e il tuo indirizzo web che altrimenti saranno eliminati presto!',
      account_expired_action: 'Rinnova subito',
      account_expired_subtitle:
        "Rinnovalo subito per continuare a usufruire di tutti i vantaggi offerti dall'account Pro",
      account_expired_title: 'Il tuo account Pro è scaduto',
      expired_transfer_subtitle:
        'I file non sono più disponibili. Puoi eliminare le informazioni della panoramica dei trasferimenti  <a>qui</a>.',
      expired_transfer_title: 'Questo trasferimento è scaduto',
      account_email_verify_logged_out:
        'Effettua il login per verificare la tua e-mail',
      account_inactive_sublink: 'annulla il tuo ordine.',
      email_unverified_mobile_cta: 'Pronto per la verifica',
      email_unverified_text:
        "Abbiamo inviato un codice di verifica all'indirizzo %{email}. <a href='%{href}'>Non sei tu?</a>",
      email_unverified_text_link:
        "Abbiamo inviato un'e-mail all'indirizzo %{email}. <a href='%{href}'>Non sei tu?</a>",
      email_unverified_title: 'Verifica il tuo indirizzo e-mail',
      'force-account-verification': {
        body: 'Ti invieremo un link per essere sicuri che sei davvero tu.',
      },
      'receiving-email':
        'Attenzione! Abbiamo sostituito l\'indirizzo %{receiving_email} nel tuo profilo. Ciò significa che i nuovi trasferimenti appariranno nella panoramica dei tuoi trasferimenti solo se saranno inviati all\'indirizzo %{account_email}. Per cambiare questa impostazione, puoi aggiornare i tuoi <a href="/account">dettagli personali</a> in qualsiasi momento.',
    },
    design:
      'Probabilmente ti sarai accorto che abbiamo cambiato qualcosa qui! Molte delle modifiche riguardano cose che ci avete richiesto voi. Ti invitiamo quindi a esplorare il nuovo e (almeno secondo noi) migliorato sito e a farci sapere cosa ne pensi qui.',
    loading_error:
      'Sembra che questa pagina abbia problemi a caricarsi in questo momento. \nNoi continueremo a provare, oppure tu <a href="%{path}">prova ad aggiornarla</a>.',
    redesign_notice:
      'Probabilmente avrai notato che abbiamo <a href="/about/redesign">cambiato qualcosa</a> qui! Molte di queste modifiche ci sono state chieste da voi. Ti invitiamo quindi a esplorare il nostro nuovo e (almeno secondo noi) migliorato sito e a farci sapere <a href="/contact" rel="external">cosa ne pensi qui<a/>.',
    return_to: 'Torna a %{pageName}',
    close: 'Chiudi il pannello',
    cookie: {
      accept: 'Ok',
      text: 'Utilizziamo i cookies. Leggi qui <a href="/legal/terms">le faccende legali</a> (niente ricette).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Carriera',
      press: 'Stampa',
      terms: 'Condizioni',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: "Fai l'upgrade",
    free_limit:
      'Non puoi inviare più di 2 GB alla volta. Vuoi inviare trasferimenti più grandi?',
    compare_plans: {
      button: 'Confronta i piani',
      text: 'Puoi aggiornare il tuo piano per trasferire più di 2 GB alla volta.',
      title: 'Hai altri file da inviare?',
    },
    mobile: {
      cta: 'Scopri di più',
      header: 'Ottieni il meglio da WeTransfer',
      upsell_enjoy: 'Goditi uno storage più grande',
      upsell_one: 'Invia trasferimenti più grandi',
      upsell_two: 'Personalizza la tua pagina WeTransfer',
    },
    pro_limit:
      'Non puoi inviare più di 200 GB alla volta. Vuoi inviare trasferimenti di qualsiasi dimensione?',
  },
  upsell_tiers_one: {
    text: 'Vuoi impostare password e date di scadenza dei tuoi trasferimenti?',
  },
  upsell_tiers_three: {
    text: 'Vuoi inviare trasferimenti a più di %{email_limit} indirizzi e-mail alla volta?',
    title: 'Giusto uno di troppo',
  },
  browser: {
    assets_failed: {
      text: 'Non è stato possibile caricare alcune parti importanti del nostro sito Web. \nPotrebbero essere rimaste bloccate da un firewall, un proxy o dalla configurazione del browser. \nProva ad aggiornare la pagina o mettiti in contatto con il nostro <a href="https://wetransfer.zendesk.com" rel="external">centro di assistenza</a>.',
      title: 'Oh oh...',
    },
    javascript_needed:
      'Ti serve un browser abilitato per JavaScript per usare WeTransfer',
  },
  languages: {
    en: 'Inglese',
    nl: 'Paesi Bassi',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        "Questa offerta è disponibile fino al %{end_date}. Lo sconto si applica al primo anno di %{user_tier}, l'iscrizione verrà successivamente rinnovata al prezzo pieno di %{yearly_amount}/%{billing_period}.",
    },
    modal: {
      title: '%{discount_amount}% di sconto su Pro annuale',
      subtitle: 'Codice sconto: %{coupon_code_name}',
      text_content:
        'Il gioco è fatto. Abbiamo un affare per te. Ti offriamo il %{discount_amount}% di sconto su un piano Pro annuale.',
      argument: {
        size_limit: 'Invia e ricevi 200 GB di trasferimenti di file',
        storage_size: 'Goditi 1 TB di storage',
        unlimited_review: 'Crea revisioni illimitate',
      },
      cta_label: 'Richiedi lo sconto',
      dismiss_label: 'Non ora',
    },
    banner: {
      title:
        'Ottieni uno sconto del %{discount_amount}% su WeTransfer Pro per un anno, la nostra migliore offerta di sempre',
      cta_label: "Effettua l'upgrade",
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Trasferimenti insieme, con %{first_recipient_email}',
      subtitle:
        'Invita il tuo team a inviare e ricevere trasferimenti con il tuo piano %{user_plan}.',
      list: {
        overview_item: 'Panoramica condivisa dei trasferimenti',
        storage_limit_item:
          'Spazio di archiviazione condiviso di %{storage_limit} extra a persona',
        branding_item: 'Branding di team condiviso',
        subscription_item: 'Iscrizione e fatturazione condivise',
      },
      cta: 'Invita il team',
      dismiss_button: 'Non oggi',
    },
    second_viewing: {
      title: 'Trasferimenti insieme, con ${first_recipient_email}',
      subtitle:
        'Invita il tuo team a inviare e ricevere trasferimenti con il tuo piano %{user_plan}.',
      list: {
        overview_item: 'Panoramica condivisa dei trasferimenti',
        storage_limit_item:
          'Spazio di archiviazione condiviso di %{storage_limit} extra a persona',
        branding_item: 'Branding di team condiviso',
        subscription_item: 'Iscrizione e fatturazione condivise',
      },
      cta: 'Invita il team',
      dismiss_button: 'Nascondi per sempre',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Il tuo account è stato aggiornato',
    update_password: 'La tua password è stata aggiornata',
    update_subscription: 'Il tuo piano di pagamento è stato aggiornato',
    update_profile_success: 'Il tuo profilo è stato aggiornato',
    link_copied: 'Questo link è stato copiato nei tuoi appunti',
    copy_link_manual: 'Link selezionato; copialo usando %{shortcut}',
    delete_transfer_success: 'Questo trasferimento è stato eliminato',
    delete_transfers_success: 'I trasferimenti sono stati eliminati',
    update_expiry_success: 'La data di scadenza è stata aggiornata',
    onboarding_success:
      'Per di qui per i trasferimenti, i contatti, le impostazioni del profilo e altro',
    add_contact_success: 'Questo contatto è stato aggiunto',
    edit_contact_success: 'Questo contatto è stato aggiornato',
    remove_contact_success: 'Questo contatto è stato eliminato',
    already_signed_in: 'Ora sei registrato',
    cancel_subscription_success:
      'Ci dispiace vederti andare via. La tua sottoscrizione è stata cancellata.',
    collect_app_banner_desc:
      'Visualizza in anteprima, salva e gestisci i file nella Collect App',
    contact_added_confirmation:
      'Il contatto è stato aggiunto al tuo trasferimento',
    contact_recipient_locked_text:
      'Questa pagina è riservata al suo proprietario per ricevere file. Devi inviare file a qualcun altro?',
    forward_ready: 'Il tuo trasferimento è pronto per essere inoltrato',
    mobile_app_banner_desc: "Visualizza, salva e gestisci i file nell'app",
    mobile_app_banner_title: "Salva nell'app",
    reactivate_subscription_success:
      'Bentornato! Il suo account è stata riattivato. ',
    refresh_transfer_upload_lost:
      'Sei sicuro di voler annullare il caricamento attuale?',
    update_payment_success:
      'I tuoi dati di pagamento sono stati aggiornati con successo. Tac.',
    update_user: 'I tuoi dati sono stati aggiornati',
    current_team_notification:
      'Stai usando %{plan} in quanto parte di %{currentTeam}',
    display_name_updated: 'Titolo aggiornato!',
    download_started:
      'Il download è stato avviato. Una volta completato, i file saranno archiviati sul tuo computer (di solito nella cartella "Download").',
    logged_out:
      "Sembra che sia stato eseguito il logout da un altro browser. Effettua di nuovo l'accesso.",
    project_delete:
      'Vuoi eliminare <strong>%{projectName}</strong> e tutti i file che hai aggiunto?',
    project_delete_success: '<strong>%{projectName}</strong> è stato eliminato',
    password_changed: 'Password modificata',
    password_removed: 'Password rimossa',
  },
  alert: {
    confirm_cancel_upload_image:
      'Sei sicuro di voler annullare il caricamento attuale? ',
    cancel_recipient_locked: 'Annulla',
    cancel_refresh_transfer_upload_lost: 'No',
    confirm_refresh_transfer_upload_lost: 'Sì',
    go_to_transfer: 'Vai al trasferimento',
    redirect_recipient_locked: 'Sì',
    stay: 'Rimani',
    cancel_project_delete: 'Annulla',
    confirm_project_delete: 'Elimina',
  },
  force_update:
    "Grandi cose ti attendono! <a href=\"/\" onClick='javascript:window.location.reload();'>Aggiorna il tuo browser</a> per assicurarti di usare l'ultima versione di WeTransfer",
  user: {
    already_logged_in:
      "Hai già effettuato l'accesso, sei sicuro di voler ripristinare la password?",
    roles: {
      admin: 'amministratore',
      owner: 'proprietario',
      user: 'utente',
    },
    sign_out_and_reset: 'Esci e ripristina la password',
  },
  click_here: 'Clicca qui',
  cookiebox: {
    notice:
      '<bold>Sei attualmente connesso</bold>, verrai disconnesso dopo avere eliminato i cookie. Questo non avrà alcuna ripercussione sui trasferimenti passati del tuo account.',
  },
  notice: {
    general_issues:
      'Qualcosa non funziona come dovrebbe? Sappiamo quanto possa essere frustrante, ma tieni duro. Vedrai che tornerà tutto operativo <a target="_blank" href=%{link}>appena possibile</a>',
    transfer_issues:
      'Stai avendo qualche problema con il tuo trasferimento? Sappiamo quanto possa essere frustrante, ma tieni duro. Vedrai che tornerà tutto operativo <a target="_blank" href=%{link}>appena possibile</a>',
    verification:
      'Ehi, abbiamo bisogno che <a href="/account">confermi la tua e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Info | WeTransfer',
      advertise: 'Promuovi le tue pubblicità | WeTransfer',
      apps: 'App gratuite per Mac, iOS e Android | App WeTransfer',
      forgot_password: 'Reimposta la tua password | WeTransfer Pro',
      help: 'Come inviare file di grandi dimensioni | WeTransfer Help',
      home: 'Condividi facilmente file di grandi dimensioni gratis | WeTransfer',
      plus: "Effettua l'upgrade per inviare file più grandi | WeTransfer Pro",
      sign_in: 'Registrazione | WeTransfer Pro',
      sign_up: 'Registrati | WeTransfer Pro',
      upgrade: "Effettua l'upgrade | WeTransfer Pro",
      pricing:
        'Prezzi | WeTransfer - Invia file di grandi dimensioni e condividi foto online - Gratis fino a 2 GB',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Non hai ancora trovato quello che stai cercando?',
    },
  },
  splash: {
    footer: {
      or: 'o',
      send_files: 'Voglio solo inviare i miei file',
      no_thanks: 'No, grazie',
    },
    heading: {
      line_1_free:
        'WeTransfer è il modo migliore per inviare file di grandi dimensioni',
      line_2_free: 'Ottieni di più da WeTransfer',
      free_account: 'Bentornato. Vogliamo rendere la cosa ufficiale?',
    },
    plan: {
      plus: {
        feature_10: 'Personalizza le tue e-mail',
        feature_11: 'Salva fino a %{plus_storage_limit}',
        feature_12: 'Decidi quando fissare la scadenza dei trasferimenti',
        feature_13: 'Proteggi i tuoi trasferimenti con una password',
        feature_7: 'Personalizza il tuo profilo',
        feature_8: 'Crea la tua rubrica',
        feature_9: 'Personalizza il tuo url WeTransfer',
      },
      free_account: {
        cta: 'Registrati gratuitamente',
        feature_1: 'Nessuno storage',
        feature_2: 'inviare fino a %{free_transfer_limit}',
        feature_3: 'Invia di nuovo ed elimina i trasferimenti',
        heading: 'Account WeTransfer',
        price_label: 'Gratis per sempre',
      },
      pro: {
        cta: 'Ottieni WeTransfer Pro',
        feature_1: '%{storage_limit_pro} di storage',
        feature_2: 'Invia e ricevi fino a %{transfer_limit_pro}',
        feature_2_unlimited: 'Invia e ricevi file senza limiti di dimensioni',
        feature_3: 'Invia di nuovo ed elimina i trasferimenti',
        feature_4: 'Proteggere i tuoi trasferimenti con una password',
        feature_5: 'La tua pagina Pro e URL personale',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Vuoi aggiungere %{recipient} al tuo team?',
      text_content:
        'I membri del team possono accedere reciprocamente ai trasferimenti con storage e branding condivisi. Questa scelta non annullerà il trasferimento.',
      cta: 'Dimmi tutto',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link copiato',
      copy: 'Copia il link',
      copy_again: 'Copia ancora',
    },
    labels: {
      share: 'Condividi questo trasferimento',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'CONSIGLIO DA PRO',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Prova i nostri portali',
        dismiss: 'Non ora',
        text: 'Puoi invitare i tuoi clienti e collaboratori a visualizzare il tuo lavoro e a scegliere ciò che preferiscono con i nostri <strong>portali</strong>. Per un futuro con meno e-mail botta e risposta.',
        title: 'Hai bisogno di un feedback sul tuo lavoro—tipo subito?',
      },
      'second-viewing': {
        cta: 'Prova subito i nostri portali',
        dismiss: 'Non mostrarmi più questo messaggio',
        text: "Ottieni velocemente un feedback e condividi nuove versioni—tutto in un unico luogo. Con i nostri <strong>portali</strong> il tuo lavoro è in continuo movimento, passando rapidamente dalla revisione alla correzione, all'ok finale.",
        title: 'Hai inviato il tuo lavoro. E ora?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Vai su Branding',
        text_2: 'Vuoi aggiungere i tuoi video o le tue immagini?',
      },
      individual: {
        cta: 'Imposta la pagina',
        text: "Fai un'ottima impressione ogni volta che qualcuno scarica i tuoi file— aggiungi video o immagini e scegli un URL tutto tuo.",
        title: 'Getta le basi con la tua pagina WeTransfer',
      },
      invitee: {
        cta: 'Ho capito',
        text_1:
          "Con la pagina WeTransfer personalizzata del tuo team, farai sempre un'ottima impressione ogni volta che condividi il tuo lavoro.",
        text_2:
          'Puoi cambiare gli sfondi del tuo team in qualsiasi momento su <strong>Branding</strong>.',
        title: 'Sfoggia il tuo lavoro (di squadra)',
      },
      not_now: 'Non ora',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Imposta la pagina',
                  premium: {
                    text: 'Chiunque può inviarti trasferimenti di qualsiasi dimensione dalla pagina WeTransfer del tuo team.',
                  },
                  text: 'Chiunque può inviarti %{transfer_limit_pro} di trasferimenti dalla pagina WeTransfer del tuo team',
                },
                premium: {
                  transfer_link: {
                    text: 'Chiunque può inviarti trasferimenti di qualsiasi dimensione dal link %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Chiunque può inviarti fino a %{transfer_limit_pro} di trasferimenti da %{custom_link}',
                },
              },
              premium: {
                text: 'Chiunque può inviarti trasferimenti di qualsiasi dimensione dalla pagina WeTransfer del tuo team—ti basterà solo condividere questo link.',
              },
              regular: {
                cta: 'Ho capito',
                text: 'Chiunque può inviarti trasferimenti da <strong>%{transfer_limit_pro}</strong> dalla pagina WeTransfer del tuo team. Basta che condividi questo link.',
                title: 'Tutto ciò che il tuo team riceve, in un unico luogo',
              },
            },
            sent: {
              regular: {
                cta: 'Ho capito',
                text: 'Benvenuto nella panoramica condivisa dei trasferimenti inviati dal tuo team. Puoi tenere traccia dei download, cambiare le date di scadenza e addirittura modificare o cancellare i trasferimenti degli altri membri—anche se sarebbe carino farglielo sapere prima di cancellare a caso!',
                title: 'Gestisci i trasferimenti del tuo team',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus diventa WeTransfer Pro con 1 TB di storage — 10 volte più di prima. <a href="/transfers">Dai un\'occhiata.</a>',
  },
  refer_friend: {
    title: 'Presentaci i tuoi amici',
    account: {
      description:
        'Regaleremo a te e a un tuo amico 10 $ al momento della sua registrazione a WeTransfer Pro o Premium. Condividi il tuo link di presentazione e verrai ricompensato con carte prepagate, donazioni di beneficenza o carte regalo di centinaia di partner.',
    },
    window: {
      link: 'Ottieni il link di presentazione',
      send_another: 'Continua',
      text: 'Regaleremo a te e a un tuo amico <strong>10 $</strong> al momento della sua registrazione a WeTransfer Pro o Premium.',
      title: 'Presenta un amico',
      title_2: 'per inviare trasferimenti.',
    },
    message: {
      success:
        'Hai un grande amico! Registrati a WeTransfer Pro o Premium e sia tu che il tuo amico sarete ricompensati con una carta prepagata, una donazione di beneficenza o una carta regalo del valore di 10 $.',
      self: 'Oh no, il link di presentazione non sembra corretto. Richiedi al tuo amico un nuovo link per ricevere 10 $ al momento della tua registrazione a WeTransfer Pro o Premium.',
      fallback:
        'Oh no, il link di presentazione non sembra corretto. Richiedi al tuo amico un nuovo link per ricevere 10 $ al momento della tua registrazione a WeTransfer Pro o Premium.',
      expired: 'Siamo spiacenti, il tuo link di presentazione è scaduto.',
      dismiss: 'Ignora',
    },
  },
  order_summary: {
    coupon: {
      link: 'Applica codice promozionale',
      input_placeholder: 'Codice promozionale',
      button_label: 'Applica',
      error_message:
        'Siamo spiacenti, questo codice sconto può essere applicato solo a un abbonamento %{billing_period}.',
      generic_error_message:
        'Siamo spiacenti, questo codice non è compatibile con questa iscrizione',
      input_error_message: 'Uhm, questo codice non è valido.',
      pill_label: {
        percentage: '- %{percentage}%',
      },
    },
    total: 'Totale',
  },
  mobile_verify: {
    title: 'È tutto pronto',
    subtitle:
      "Il tuo indirizzo e-mail è stato verificato: ora puoi utilizzare l'app per inviare e ricevere trasferimenti.",
    cta: "Apri l'app WeTransfer",
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Il tuo piano attuale da <b>%{formattedintervaltotal}</b>/%{subscriptioninterval} si rinnoverà automaticamente il <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Il tuo piano attuale da <b>%{formattedTeamWorkspaceCost}</b>/%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) si rinnoverà automaticamente il <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'La tua prossima scadenza di pagamento è il <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b>/%{interval}',
    team_upgrade_calculation: '(%{membercount} membri x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Nessun limite di dimensione dei trasferimenti',
    premium_feature_two: 'Storage illimitato',
    premium_feature_three: 'Portali e revisioni illimitati',
    premium_feature_four:
      'Scopri <a class="all-benefits-link" href="%{all_benefits_href}">tutti i vantaggi</a>',
    premium_switch_cta_text: 'Passa a Premium',
    pill_text: 'Piano attuale',
    member_count: '%{membercount} membri',
    see_all_benefits: 'Scopri tutti i vantaggi del piano',
    pending_downgrade_current_subscription:
      "L'iscrizione al tuo spazio di lavoro è stata annullata e terminerà il <b>%{cancellation_date}</b>.",
    pending_downgrade_reactivate_text:
      'Hai cambiato idea? Niente panico: tornare operativi è un gioco da ragazzi.',
    pending_downgrade_reactivate_cta: 'Riattiva Pro',
    pending_downgrade_payment: 'Non hai pagamenti in scadenza',
    update_payment_cta: 'Aggiornamento dati di pagamento',
    cancel_plan:
      'Se annulli la tua iscrizione, potrai accedere alla tua area di lavoro %{planName} fino al %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Successivamente verrà effettuato il downgrade del tuo spazio di lavoro al piano gratuito e i trasferimenti presenti scadranno dopo 28 giorni.',
    pending_payment_text:
      "Per visualizzare il tuo piano e le informazioni relative al pagamento, completa il pagamento o annulla l'ordine.",
    learn_more: 'Maggiori informazioni su piani e prezzi',
  },
  time: {
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    },
    months: {
      january: 'Gennaio',
      february: 'Febbraio',
      march: 'Marzo',
      april: 'Aprile',
      may: 'Maggio',
      june: 'Giugno',
      july: 'Luglio',
      august: 'Agosto',
      september: 'Settembre',
      october: 'Ottobre',
      november: 'Novembre',
      december: 'Dicembre',
    },
    remaining: {
      minutes: {
        zero: 'Manca meno di un minuto...',
        one: 'Manca circa 1 minuto',
        other: 'Mancano circa %{count} minuti',
      },
      hours: {
        one: 'Manca circa 1 ora',
        other: 'Mancano circa %{count} ore',
      },
    },
  },
  download: {
    shortcut:
      "Premi %{command} per visualizzare l'<br />avanzamento del download",
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Invia fino a %{size}',
    progress: {
      busy: 'Trasferimento...',
    },
    buttons: {
      add: 'Aggiungi file',
      transfer: 'Trasferisci',
      forward: 'Invio',
      add_ios6: 'Aggiungi foto e video',
      add_ios7: 'Aggiungi foto',
    },
    forward: {
      done: 'Invio completato',
    },
    friend_email: {
      title: 'E-mail di un amico',
      more: 'Aggiungi altri amici',
    },
    your_email: {
      title: 'La tua e-mail',
    },
    message: {
      title: 'Messaggio',
    },
    done: {
      title: 'Trasferimento completato',
      link: 'Copia il tuo link di download:',
      copied: {
        title: 'Copiato!',
        text: 'Il link di download è stato copiato.',
      },
    },
    more_html: 'Aggiungi altri file<span>(%{size} rimasti)</span>',
    too_many_recipients:
      "Sembra che tu abbia inserito troppi indirizzi e-mail. Ricorda: c'è spazio per un massimo di %{count} persone per volta.",
    completed: '%{size} di %{total} completati',
    addresses: {
      one: '%{count} indirizzo',
      other: '%{count} indirizzi',
      remove: 'Vuoi eliminare %{address} dai tuoi destinatari precedenti?',
    },
    ads: {
      plus: {
        title: 'Ottieni il massimo da WeTransfer con Pro',
        text: "<ul><li>Caricamenti dati di grandi dimensioni</li><li>Trasferimenti personalizzati con i tuoi sfondi</li><li>Trasferimenti protetti da password</li><li>Archiviazione dati a lungo termine</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Scopri di più</a></p>",
      },
      plus2: {
        title: 'Stupisci personalizzando la tua pagina di download',
        text: "<p>Usa i tuoi sfondi preferiti e personalizza l'URL di WeTransfer (iltuonome.wetransfer.com)<br />per stupire i tuoi destinatari.</p><p><a target='_blank' href='/pro?trk=inapp'>Scopri di più</a></p>",
      },
      plus3: {
        title: 'Gestisci i tuoi trasferimenti in modo intelligente',
        text: "<p>Questo trasferimento sarà cancellato dopo 1 settimana. Con WeTransfer Pro invece puoi archiviare per un tempo indeterminato, inoltrare e cancellare quando vuoi senza dover caricare nuovamente il tuo file.</p><p><a target='_blank' href='/pro?trk=inapp'>Scopri di più</a></p>",
      },
      plus4: {
        title: 'Ottieni una protezione extra per i tuoi files',
        text: "<p>Con WeTransfer Pro, puoi proteggere i tuoi file più importanti e confidenziali con una password.</p><p>In questo modo, non corrono il rischio di cadere in mani sbagliate.</p><p><a target='_blank' href='/pro?trk=inapp'>Scopri di più</a></p>",
      },
      facebook: {
        title: 'Unisciti alla<br />comunità WeTransfer<br />su Facebook',
        text: "<p>Ricevi le ultime notizie, vinci premi, scopri nuovi artisti, leggi interviste e molto di più.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Scopri di più</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        "Siamo spiacenti, quando si invia nuovamente un trasferimento, solo l'e-mail è supportato.",
      connect_twitter:
        'Il tuo account Twitter non è ancora collegato a WeTransfer.',
      connect_facebook:
        'Il tuo account Facebook non è ancora collegato a WeTransfer.',
      transferproblems: {
        title: 'Problema di trasferimento.',
        text: 'Siamo davvero spiacenti, ma si è verificato un errore durante il trasferimento.',
      },
      limitreached: {
        title: 'Limite di Archiviazione',
        text: 'Hai raggiunto il limite di 1 TB. Elimina vecchi trasferimenti per inviare nuovi file',
      },
      blocked: {
        title: 'Problema di trasferimento.',
        text: "Il computer ha negato l'operazione. Siamo spiacenti, sei stato bloccato da WeTransfer.",
      },
      upload_error: {
        title: 'Problema di trasferimento.',
        text: 'Siamo davvero spiacenti, ma si è verificato un errore durante il trasferimento.',
      },
      unavailable: {
        title: 'Errore di trasferimento',
        text: 'Siamo spiacenti, ma questo trasferimento è stato già cancellato e non può essere inoltrato.',
      },
      startswithdot: {
        title: 'Ops!',
        text: 'Il nome di uno (o più) file comincia con ., non funzionerà! Ti preghiamo di rinominare il/i file e aggiungerli di nuovo.',
      },
      startswithspace: {
        title: 'Ops!',
        text: 'Il nome di uno (o più) file comincia con uno spazio, non funzionerà! Ti preghiamo di rinominare il/i file e aggiungerli di nuovo.',
      },
      containsreturn: {
        title: 'Ops!',
        text: 'Uno (o più) file contengono un invio a capo. Non sappiamo come tu abbia fatto, ma non potrà funzionare. Ti preghiamo di rinominare il/i file e aggiungerli di nuovo.',
      },
      alreadyinlist: {
        title: 'Accidenti!',
        text: 'Uno dei file ha lo stesso nome di un altro file da te già selezionato. Ti preghiamo di modificarlo.',
      },
      transfertoobig: {
        title: 'Oh-oh',
        text: 'Siamo spiacenti, ma non è possibile trasferire più di %{upload_limit} GB alla volta.',
      },
      filetoobig: {
        title: 'Oh-oh',
        text: 'Siamo spiacenti, ma non è possibile trasferire più di %{upload_limit} GB alla volta.',
      },
      zerobytes: {
        title: 'Ops!',
        text: 'Uno (o più) file sono vuoti o non è possibile leggerli.',
      },
      ioerror: {
        title: 'Errore',
        text: 'Uno (o più) file non possono essere letti o eccedono il limite di %{upload_limit} GB. Non potrà funzionare.',
      },
      filenametoolong: {
        title: 'Accidenti!',
        text: 'Il nome di uno (o più) file supera il numero massimo di 250 caratteri consentiti, ti preghiamo di rinominarlo.',
      },
      nofolders: {
        title: 'Oh-oh',
        text: 'Siamo spiacenti, il caricamento di cartelle non è ancora attivo. Prova prima a comprimerla.',
      },
      nofiles: {
        title: 'Ops!',
        text: 'Non hai ancora aggiunto nessun file.',
      },
      norecipients: {
        title: "D'oh!",
        text: 'Hai dimenticato di inserire gli indirizzi e-mail dei destinatari.',
      },
      toomanyrecipients: {
        title: 'Accidenti!',
        text: 'Troppi destinatari.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Il tuo messaggio più lungo di un romanzo. Accorcialo, per favore.',
      },
      nosender: {
        title: 'Davvero?',
        text: 'Non hai inserito il tuo indirizzo e-mail...come mai?',
      },
      senderemailinvalidformat: {
        title: 'Oh-oh',
        text: 'Il tuo indirizzo e-mail sembra errato, controlla lo spelling!',
      },
      probablynotcopied: {
        title: 'Ops',
        text: 'Il link non è stato copiato.',
      },
      recipientemailinvalidformat: {
        title: 'Ops!',
        text: 'Uno degli indirizzi e-mail dei tuoi amici non è corretto.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Accidenti!',
        text: 'Uno (o più) file hanno un nome che contiene il simbolo di barra retroversa. Ti preghiamo di rinominare i file in modo che non contengano barre retroverse.',
      },
      title: 'Ops',
      text: "iOS7 non permette di inviare video tramite il nostro sito, ma puoi farlo utilizzando la nostra fantastica app</a> WeTransfer <a href='%{wetransfer_ios_app_store_url}'>!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Consiglio',
        text: 'Puoi inviare fino a 2 GB a trasferimento. E, cosa ancora più sorprendente, puoi trasferire file tutte le volte che vuoi.',
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Importante',
        text: "L'account Pro può inviare fino a 20 GB a trasferimento, ma il tuo browser non lo permette. <a href=/questions/33>Fai clic qui per maggiori informazioni.</a>",
      },
      recipients_tip: {
        title: 'Consiglio',
        text: 'Puoi inserire fino a %{email_limit} indirizzi e-mail di destinazione. Se vuoi solo un link di download, fai clic sul seguente pulsante di condivisione.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Consiglio',
        text: 'Scrivi qui il tuo indirizzo e-mail per potere ricevere notifica quando i file saranno scaricati.',
      },
      expire_tip: {
        title: 'Suggerimento',
        text: 'Ora puoi modificare la data di scadenza dei tuoi trasferimenti Pro.',
      },
      message_tip: {
        title: 'Consiglio',
        text: 'Vuoi inviare ai tuoi amici un messaggio insieme ai file? Se vuoi, puoi farlo ora.',
      },
      share_tip: {
        title: 'Consiglio',
        text: 'Modifica il modo di condividere i tuoi file. Inviali per e-mail o ottieni un link di download.',
        text_plus:
          'Modifica il modo di condividere i tuoi file. Inviali per e-mail, Twitter, Facebook o ottieni un link di download.',
      },
      download: {
        title: '',
        chrome:
          "Il download funziona diversamente rispetto a prima. Ora scarichiamo tutti i file dal browser, quindi non vedrai più il progresso su WeTransfer e probabilmente non ti verrà chiesto dove archiviare il file. Il progresso del download dovrebbe essere visibile nella parte inferiore della finestra del browser e il tuo file sarà automaticamente archiviato sulla tua cartella Download. <a href='/questions/24' target='_blank'>Scopri qui </a> come cambiare questa impostazione.",
        firefox:
          "Il download funziona diversamente rispetto a prima. Ora scarichiamo tutti i file dal browser, quindi non vedrai più il progresso su WeTransfer e probabilmente non ti verrà chiesto dove archiviare il file. Il progresso del download dovrebbe essere visibile nella finestra di download del browser e il tuo file sarà automaticamente archiviato sulla tua cartella Download. <a href='/questions/24' target='_blank'>Maggiori informazioni</a>.",
        safari:
          "Il download funziona diversamente rispetto a prima. Ora scarichiamo tutti i file dal browser, quindi non vedrai più il progresso su WeTransfer e probabilmente non ti verrà chiesto dove archiviare il file. Il progresso del download dovrebbe essere visibile sull'angolo in alto a destra della finestra del browser e il tuo file sarà automaticamente archiviato sulla tua cartella Download. <a href='/questions/24' target='_blank'>Maggiori informazioni</a>.",
        old_explorer:
          "Il download funziona diversamente rispetto a prima. Ora scarichiamo tutti i file dal browser, quindi non vedrai più il progresso su WeTransfer e probabilmente non ti verrà chiesto dove archiviare il file. Postresti inoltre vedere un avviso di sicurezza nella parte superiore della finestra del browser.  <a href='/questions/24' target='_blank'>Maggiori informazioni</a>.",
        explorer:
          "Il download funziona diversamente rispetto a prima. Ora scarichiamo tutti i file dal browser, quindi non vedrai più il progresso su WeTransfer e probabilmente non ti verrà chiesto dove archiviare il file. Il progresso del download dovrebbe essere visibile nella parte inferiore della finestra del browser (probabilmente dovrai prima cliccare su Salva) e il tuo file sarà automaticamente archiviato sulla tua cartella Download. <a href='/questions/24' target='_blank'>Maggiori informazioni</a>.",
        settings:
          'Puoi cambiare la destinazione predefinita dei tuoi download dalle impostazioni del tuo browser.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Inoltrando questo trasferimento, il contenuto del modulo verrà cancellato, desideri procedere?',
    is_busy:
      'Siamo spiacenti, al momento non è possibile effettuare questa operazione.',
  },
  mobile_app: {
    remember_choice: 'Non visualizzare più questo messaggio',
    uploader: {
      description:
        'Il nostro sito non è ancora ottimizzato per i cellulari,  però abbiamo una fantastica app da poter utilizzare.',
      app_name: 'WeTransfer',
      download: "Scarica l'app",
      continue: 'Continua su WeTransfer.com',
    },
    downloader: {
      title: 'I tuoi file sono pronti per il download',
      description_ios:
        'Abbiamo riunito i tuoi file in un unico file zip. Per estrarli e visualizzarli avrai bisogno di una app. Secondo noi l’app <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> fa al caso tuo.',
      description_android:
        'Abbiamo riunito i tuoi file in un unico file zip. Per estrarli e visualizzarli avrai bisogno di una app. Secondo noi l’app <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> fa al caso tuo.',
      continue: 'Capito',
    },
  },
};
